    import {
      Room,
      RoomEvent,
      ParticipantEvent,
      ConnectionState,
    } from 'livekit-client';

    window.__voiceBoot = { stage: 'module-imported' };

    const GOOGLE_CLIENT_ID = window.__VOICE_CONFIG__?.googleClientId || '';
    // BYD's cabin speakers are close enough to the dashboard microphone that
    // relying on browser defaults is insufficient. Request the WebRTC audio
    // processing constraints explicitly for both permission preflight and the
    // track LiveKit publishes.
    const MICROPHONE_CAPTURE_OPTIONS = Object.freeze({
      echoCancellation: true,
      noiseSuppression: true,
      autoGainControl: true,
      channelCount: 1,
    });

    let AGENTS = [
      { id: 'sevro',   name: 'Sevro',   emoji: '🐺', language: 'en', tagline: 'Feral genius. Ride or die.' },
      { id: 'cassius', name: 'Cassius', emoji: '☀️', language: 'en', tagline: 'Golden eloquence.' },
      { id: 'mustang', name: 'Mustang', emoji: '🐎', language: 'en', tagline: 'Sharp mind, warm heart.' },
      { id: 'reaper',  name: 'Reaper',  emoji: '⚔️', language: 'en', tagline: 'Cold. Tactical. Decisive.' },
      { id: 'sanaa',   name: 'Sanaa',   emoji: '✨', language: 'fr', tagline: 'Radiance and clarity.' },
      { id: 'sophie',  name: 'Sophie',  emoji: '🌟', language: 'fr', tagline: 'Telepathic kindness.' },
      { id: 'bambi',   name: 'Bambi Shore', emoji: '🌊', language: 'en', tagline: 'Beach-glam charm. Bite included.' },
      { id: 'main',    name: 'CynicalHelper', emoji: '🦞', language: 'en', tagline: 'Sarcastic but effective.' },
      { id: 'trump',   name: 'Trump',   emoji: '🇺🇸', language: 'en', tagline: 'Tremendous. Believe me.' },
    ];

    const LIVEKIT_URL = window.LIVEKIT_URL || (window.location.protocol === 'https:' ? `wss://${window.location.host}/livekit/` : 'ws://localhost:7880');

    const authScreen = document.getElementById('auth-screen');
    const appShell = document.getElementById('app-shell');
    const authError = document.getElementById('auth-error');
    const googleSigninSlot = document.getElementById('google-signin-slot');
    const authUser = document.getElementById('auth-user');
    const authUserAvatar = document.getElementById('auth-user-avatar');
    const authUserName = document.getElementById('auth-user-name');
    const accountAvatar = document.getElementById('account-avatar');
    const accountName = document.getElementById('account-name');
    const logoutBtn = document.getElementById('logout-btn');
    const grid = document.getElementById('agent-grid');
    const connectBtn = document.getElementById('connect-btn');
    const statusEl = document.getElementById('status');
    const selectScreen = document.getElementById('select-screen');
    const callScreen = document.getElementById('call-screen');
    const callAvatar = document.getElementById('call-avatar');
    const callAvatarFallback = document.getElementById('call-avatar-fallback');
    const endCallBtn = document.getElementById('end-call-btn');
    const newCallBtn = document.getElementById('new-call-btn');
    const muteBtn = document.getElementById('mute-btn');
    const muteLabel = document.getElementById('mute-label');
    const audioBtn = document.getElementById('audio-btn');
    const audioHint = document.getElementById('audio-hint');
    const remoteAudioContainer = document.getElementById('remote-audio-container');
    const newSessionBtn = document.getElementById('new-session-btn');
    const sessionIndicator = document.getElementById('session-indicator');
    const userRing = document.getElementById('user-ring');
    const agentRing = document.getElementById('agent-ring');
    const userLabel = document.getElementById('user-label');
    const agentLabel = document.getElementById('agent-label');
    const speakingStatus = document.getElementById('speaking-status');
    const waveform = document.getElementById('waveform');
    const callTimer = document.getElementById('call-timer');
    const chatToggle = document.getElementById('chat-toggle');
    const chatPanel = document.getElementById('chat-panel');
    const chatClose = document.getElementById('chat-close');
    const chatLog = document.getElementById('chat-log');
    const imageViewer = document.getElementById('image-viewer');
    const imageViewerImage = document.getElementById('image-viewer-image');
    const imageViewerCaption = document.getElementById('image-viewer-caption');
    const imageViewerClose = document.getElementById('image-viewer-close');
    const chatCommandButtons = Array.from(document.querySelectorAll('.chat-command-btn'));
    const historyBtn = document.getElementById('history-btn');
    const historyOverlay = document.getElementById('history-overlay');
    const historyClose = document.getElementById('history-close');
    const historyFilters = document.getElementById('history-filters');
    const historyList = document.getElementById('history-list');
    const historyDetail = document.getElementById('history-detail');
    const historyBack = document.getElementById('history-back');
    const historyTitle = document.getElementById('history-title');
    const historyDetailMeta = document.getElementById('history-detail-meta');
    const historyTranscript = document.getElementById('history-transcript');
    const historyContinue = document.getElementById('history-continue');
    const historySearch = document.getElementById('history-search');
    const selectedAgentSummary = document.getElementById('selected-agent-summary');
    const microphoneStatus = document.getElementById('microphone-status');
    const attachmentCapability = document.getElementById('attachment-capability');
    const callStateStrip = document.getElementById('call-state-strip');
    const callStateLabel = document.getElementById('call-state-label');
    const callStateDetail = document.getElementById('call-state-detail');
    const attachmentStatus = document.getElementById('attachment-status');
    const firstCallTip = document.getElementById('first-call-tip');

    const visionBtn = document.getElementById('vision-btn');
    const visionLabel = document.getElementById('vision-label');
    const visionPreview = document.getElementById('vision-preview');
    const visionVideo = document.getElementById('vision-video');
    const cameraSelectWrap = document.getElementById('camera-select-wrap');
    const cameraSelect = document.getElementById('camera-select');
    const connectionMethodSelect = document.getElementById('connection-method');
    const sttProviderSelect = document.getElementById('stt-provider');
    const STORED_CONNECTION_METHOD = localStorage.getItem('connection_method') || 'default';
    if (connectionMethodSelect) {
      connectionMethodSelect.value = STORED_CONNECTION_METHOD;
      connectionMethodSelect.addEventListener('change', () => {
        localStorage.setItem('connection_method', connectionMethodSelect.value);
      });
    }
    const STORED_STT_PROVIDER = localStorage.getItem('stt_provider') || 'local';
    if (sttProviderSelect) {
      sttProviderSelect.value = STORED_STT_PROVIDER;
      sttProviderSelect.addEventListener('change', () => {
        localStorage.setItem('stt_provider', sttProviderSelect.value);
      });
    }
    const userVideo = document.getElementById('user-video');
    const userMicEmoji = document.querySelector('.user-icon .mic-emoji');
    const agentAvatarWrap = document.getElementById('agent-avatar-wrap');

    function avatarPath(agentId) { return `avatars/small/${agentId}.png`; }

    async function refreshMicrophoneReadiness() {
      if (!microphoneStatus) return;
      if (!navigator.mediaDevices?.getUserMedia) {
        microphoneStatus.textContent = 'Not supported in this browser';
        return;
      }
      try {
        const permission = await navigator.permissions?.query?.({ name: 'microphone' });
        microphoneStatus.textContent = permission?.state === 'denied'
          ? 'Permission blocked — change browser settings'
          : permission?.state === 'granted' ? 'Ready' : 'Permission requested when call starts';
      } catch {
        microphoneStatus.textContent = 'Permission requested when call starts';
      }
    }

    let room = null;
    let isConnecting = false;
    let audioElements = new Map();
    let audioAnalyzers = new Map();
    let agentAudioContext = null;
    let agentMouthRaf = null;
    let selectedAgent = null;
    let timerInterval = null;
    let callStartTime = null;
    let currentUser = null;
    let prevStatusText = '';
    let prevStatusTimer = null;
    let visionEnabled = false;
    let visionCapable = false;  // set from /api/token response
    let availableVideoInputs = [];
    const CAMERA_PREFERENCE_KEY = 'voice-camera-preference';
    const CAMERA_PREF_AUTO = 'auto';
    const CAMERA_PREF_ENVIRONMENT = 'environment';
    const CAMERA_PREF_DEVICE_PREFIX = 'device:';
    let selectedCameraPreference = loadCameraPreference();

    function loadCameraPreference() {
      try {
        return localStorage.getItem(CAMERA_PREFERENCE_KEY) || CAMERA_PREF_AUTO;
      } catch {
        return CAMERA_PREF_AUTO;
      }
    }

    function persistCameraPreference(value) {
      selectedCameraPreference = value || CAMERA_PREF_AUTO;
      try {
        localStorage.setItem(CAMERA_PREFERENCE_KEY, selectedCameraPreference);
      } catch {
        // Ignore storage failures and keep the preference in memory for this session.
      }
    }

    function classifyVideoInput(device) {
      const label = String(device?.label || '').toLowerCase();
      if (/(back|rear|environment|world)/.test(label)) return 'environment';
      if (/(front|facetime|user)/.test(label)) return 'user';
      return 'unknown';
    }

    function findEnvironmentVideoInput(devices = availableVideoInputs) {
      return devices.find((device) => classifyVideoInput(device) === 'environment') || null;
    }

    function getCameraOptionLabel(device, index) {
      const label = String(device?.label || '').trim();
      const facing = classifyVideoInput(device);
      if (!label) return `Camera ${index + 1}`;
      if (facing === 'environment' && !/(back|rear)/i.test(label)) return `Back camera (${label})`;
      if (facing === 'user' && !/(front|facetime)/i.test(label)) return `Front camera (${label})`;
      return label;
    }

    function getCameraPreferenceOption(deviceId) {
      return `${CAMERA_PREF_DEVICE_PREFIX}${deviceId}`;
    }

    function getPreferredMirrorState(preference = selectedCameraPreference, devices = availableVideoInputs) {
      if (preference === CAMERA_PREF_ENVIRONMENT) return false;
      if (!preference.startsWith(CAMERA_PREF_DEVICE_PREFIX)) return true;
      const deviceId = preference.slice(CAMERA_PREF_DEVICE_PREFIX.length);
      const device = devices.find((item) => item.deviceId === deviceId);
      return classifyVideoInput(device) !== 'environment';
    }

    function applyCameraMirror(preference = selectedCameraPreference, devices = availableVideoInputs) {
      const shouldMirror = getPreferredMirrorState(preference, devices);
      const transform = shouldMirror ? 'scaleX(-1)' : 'none';
      userVideo.style.transform = transform;
      visionVideo.style.transform = transform;
    }

    function buildCameraCapturePlan(preference = selectedCameraPreference, devices = availableVideoInputs) {
      // Use `ideal` hints rather than `exact`. `exact` throws OverconstrainedError
      // on devices that don't match (so iOS Safari can fall back to a cached
      // permission for the *other* camera and silently keep the wrong stream
      // active). The selectedCameraPreference is restored as the user-facing
      // signal; restartTrack() in switchActiveCamera does the actual hardware
      // swap via the LiveKit publication.
      if (preference === CAMERA_PREF_ENVIRONMENT) {
        const environmentDevice = findEnvironmentVideoInput(devices);
        return {
          primary: { facingMode: 'environment' },
          fallback: environmentDevice ? { deviceId: { exact: environmentDevice.deviceId } } : null,
          fallbackDeviceId: environmentDevice?.deviceId || null,
        };
      }

      if (preference.startsWith(CAMERA_PREF_DEVICE_PREFIX)) {
        const deviceId = preference.slice(CAMERA_PREF_DEVICE_PREFIX.length);
        if (!deviceId) return { primary: null, fallback: null, fallbackDeviceId: null };
        return {
          primary: { deviceId: { exact: deviceId } },
          fallback: null,
          fallbackDeviceId: deviceId,
        };
      }

      // CAMERA_PREF_AUTO — no constraint; let the browser pick the default.
      return { primary: null, fallback: null, fallbackDeviceId: null };
    }

    function updateCameraSelectVisibility() {
      const hasMultipleCameras = availableVideoInputs.length > 1;
      cameraSelectWrap.classList.toggle('visible', hasMultipleCameras);
      cameraSelect.disabled = !hasMultipleCameras;
      if (!hasMultipleCameras) cameraSelect.innerHTML = '';
    }

    function renderCameraSelect() {
      updateCameraSelectVisibility();
      if (availableVideoInputs.length <= 1) return;

      const options = [{ value: CAMERA_PREF_AUTO, label: 'Default camera' }];
      options.push({ value: CAMERA_PREF_ENVIRONMENT, label: 'Back camera' });
      availableVideoInputs.forEach((device, index) => {
        options.push({
          value: getCameraPreferenceOption(device.deviceId),
          label: getCameraOptionLabel(device, index),
        });
      });

      const currentValue = options.some((option) => option.value === selectedCameraPreference)
        ? selectedCameraPreference
        : CAMERA_PREF_AUTO;
      if (currentValue !== selectedCameraPreference) {
        persistCameraPreference(currentValue);
      }

      cameraSelect.innerHTML = '';
      for (const option of options) {
        const element = document.createElement('option');
        element.value = option.value;
        element.textContent = option.label;
        cameraSelect.appendChild(element);
      }
      cameraSelect.value = currentValue;
      applyCameraMirror(currentValue, availableVideoInputs);
    }

    async function refreshCameraDevices() {
      if (!navigator.mediaDevices?.enumerateDevices) {
        availableVideoInputs = [];
        renderCameraSelect();
        return availableVideoInputs;
      }

      try {
        availableVideoInputs = (await navigator.mediaDevices.enumerateDevices())
          .filter((device) => device.kind === 'videoinput');
      } catch (err) {
        console.warn('Could not enumerate video devices:', err);
        availableVideoInputs = [];
      }

      // Log what enumerateDevices actually returned. On iOS the labels are
      // empty until the user has granted camera permission at least once; we
      // need to see this on-device when diagnosing why per-device selection
      // does not switch the camera.
      try {
        const summary = availableVideoInputs.map((d, i) => {
          const facing = classifyVideoInput(d);
          const id = d.deviceId ? String(d.deviceId).slice(0, 8) + '…' : '?';
          return `#${i} "${d.label || '(empty)'}" facing=${facing} id=${id}`;
        }).join(' | ');
        _logStatus(`Cameras enumerated (${availableVideoInputs.length}): ${summary || '(none)'}`, 'camera_enumerate');
      } catch { /* diagnostic only */ }

      renderCameraSelect();
      return availableVideoInputs;
    }

    function getLocalCameraTrack() {
      const participant = room?.localParticipant;
      if (!participant) return null;

      // LiveKit's publication lookup is slightly different across client
      // versions/browsers. Android Chrome in particular may not make the
      // camera publication visible through getTrackPublication('camera') right
      // away, even though it exists in trackPublications. Search defensively so
      // the preview and activation checks don't falsely decide the camera never
      // started.
      const direct = participant.getTrackPublication?.('camera')?.track;
      if (direct?.mediaStreamTrack) return direct;

      const pubs = participant.trackPublications;
      const values = pubs?.values ? Array.from(pubs.values()) : Object.values(pubs || {});
      for (const pub of values) {
        const track = pub?.track;
        const mediaTrack = track?.mediaStreamTrack;
        const kind = mediaTrack?.kind || track?.kind;
        const source = pub?.source || track?.source || pub?.trackName || pub?.name;
        if (mediaTrack && (kind === 'video' || source === 'camera')) return track;
      }

      return null;
    }

    async function waitForLocalCameraTrack(timeoutMs = 1800) {
      const started = Date.now();
      while (Date.now() - started < timeoutMs) {
        const track = getLocalCameraTrack();
        if (track?.mediaStreamTrack?.readyState === 'live') return track;
        await new Promise((resolve) => setTimeout(resolve, 80));
      }
      return getLocalCameraTrack();
    }

    function getLocalMicrophoneTrack() {
      const participant = room?.localParticipant;
      if (!participant) return null;
      const direct = participant.getTrackPublication?.('microphone')?.track;
      if (direct?.mediaStreamTrack) return direct;
      const pubs = participant.trackPublications;
      const values = pubs?.values ? Array.from(pubs.values()) : Object.values(pubs || {});
      for (const pub of values) {
        const track = pub?.track;
        const mediaTrack = track?.mediaStreamTrack;
        const kind = mediaTrack?.kind || track?.kind;
        const source = pub?.source || track?.source || pub?.trackName || pub?.name;
        if (mediaTrack && (kind === 'audio' || source === 'microphone')) return track;
      }
      return null;
    }

    async function waitForLocalMicrophoneTrack(timeoutMs = 1800) {
      const started = Date.now();
      while (Date.now() - started < timeoutMs) {
        const track = getLocalMicrophoneTrack();
        if (track?.mediaStreamTrack?.readyState === 'live') return track;
        await new Promise((resolve) => setTimeout(resolve, 80));
      }
      return getLocalMicrophoneTrack();
    }

    function clearLocalCameraPreview() {
      userVideo.style.display = 'none';
      userVideo.srcObject = null;
      if (userMicEmoji) userMicEmoji.style.display = '';
      visionPreview.style.display = 'none';
      visionVideo.srcObject = null;
    }

    function showLocalCameraPreview() {
      const camTrack = getLocalCameraTrack();
      if (!camTrack?.mediaStreamTrack) {
        clearLocalCameraPreview();
        return;
      }

      const mediaStream = new MediaStream([camTrack.mediaStreamTrack]);
      // Explicitly null first then reassign — iOS Safari sometimes keeps
      // decoding the previous MediaStream (and renders/captures frozen frames)
      // when srcObject is replaced in-place after a camera switch.
      userVideo.srcObject = null;
      userVideo.srcObject = mediaStream;
      userVideo.style.display = 'block';
      // iOS Safari does not always auto-play after srcObject swap even with
      // the autoplay/playsinline/muted attributes — explicit play() ensures
      // the element keeps decoding frames so canvas snapshots are fresh.
      try { userVideo.play()?.catch(() => {}); } catch { /* autoplay is best effort */ }
      if (userMicEmoji) userMicEmoji.style.display = 'none';
      visionPreview.style.display = 'none';
      visionVideo.srcObject = null;
    }

    async function setCameraEnabledWithPlan(enabled, plan = buildCameraCapturePlan()) {
      if (!enabled) {
        await room.localParticipant.setCameraEnabled(false);
        return;
      }

      if (!plan.primary) {
        _logStatus('Camera enable: no constraint (default)', 'camera_plan');
        await room.localParticipant.setCameraEnabled(true);
        const track = await waitForLocalCameraTrack();
        if (!track?.mediaStreamTrack) throw new Error('Camera did not publish a video track');
        return;
      }

      try {
        _logStatus(`Camera enable primary: ${JSON.stringify(plan.primary)}`, 'camera_plan');
        await room.localParticipant.setCameraEnabled(true, plan.primary);
        const track = await waitForLocalCameraTrack();
        if (!track?.mediaStreamTrack) throw new Error('Camera did not publish a video track');
      } catch (err) {
        if (!plan.fallback) throw err;
        _logStatus(`Camera enable fallback: ${JSON.stringify(plan.fallback)} (after ${err?.name || 'error'})`, 'camera_plan');
        await room.localParticipant.setCameraEnabled(true, plan.fallback);
        const track = await waitForLocalCameraTrack();
        if (!track?.mediaStreamTrack) throw new Error('Camera did not publish a video track', { cause: err });
      }
    }

    async function switchActiveCamera(preference = selectedCameraPreference) {
      const plan = buildCameraCapturePlan(preference);
      const cameraTrack = getLocalCameraTrack();

      const existingLabel = cameraTrack?.mediaStreamTrack?.label || '(none)';
      const existingState = cameraTrack?.mediaStreamTrack?.readyState || '(none)';
      _logStatus(`Camera switch → preference=${preference} | existing=${existingLabel} state=${existingState} | primary=${JSON.stringify(plan.primary)}`, 'camera_switch');

      if (!cameraTrack) {
        await setCameraEnabledWithPlan(true, plan);
        return;
      }

      if (!plan.primary) {
        // AUTO: no constraint. Toggle camera off/on so the browser re-picks
        // its default. This is also the only path that has ever reliably
        // worked on iOS Safari after the user grants camera permission.
        await room.localParticipant.setCameraEnabled(false);
        await room.localParticipant.setCameraEnabled(true);
        return;
      }

      // Prefer restartTrack() — it mutates the existing MediaStreamTrack in
      // place and keeps the LiveKit publication alive, so the backend sees a
      // continuous video track. This is the path that was working before the
      // 2026-05-14 unpublish/republish regression.
      if (typeof cameraTrack.restartTrack === 'function') {
        try {
          await cameraTrack.restartTrack(plan.primary);
          return;
        } catch (err) {
          _logStatus(`Camera restartTrack failed (${err?.name || 'error'}); trying fallback`, 'camera_switch');
          if (!plan.fallback) throw err;
          if (plan.fallbackDeviceId && typeof cameraTrack.setDeviceId === 'function') {
            await cameraTrack.setDeviceId(plan.fallbackDeviceId);
            return;
          }
          await cameraTrack.restartTrack(plan.fallback);
          return;
        }
      }

      if (plan.fallbackDeviceId && typeof cameraTrack.setDeviceId === 'function') {
        await cameraTrack.setDeviceId(plan.fallbackDeviceId);
        return;
      }

      // Last-resort fallback if neither restartTrack nor setDeviceId is
      // available on this SDK build.
      await room.localParticipant.setCameraEnabled(false);
      await setCameraEnabledWithPlan(true, plan);
    }

    let cameraSnapshotSeq = 0;
    let lastCameraSnapshotAt = 0;

    // Default 512px live snapshot used at speech_start / speech_end. Kept
    // small and cheap (~30-100KB) since it fires twice per turn.
    // Pass force=true to bypass the 650ms throttle (e.g. explicit camera switch).
    async function sendCameraSnapshot(reason = 'turn', { force = false } = {}) {
      if (!visionEnabled || !room || room.state !== 'connected') return;
      const now = Date.now();
      if (!force && now - lastCameraSnapshotAt < 650) return;
      const camTrack = getLocalCameraTrack();
      if (!camTrack?.mediaStreamTrack || camTrack.mediaStreamTrack.readyState !== 'live') return;
      const video = userVideo;
      if (!video || video.readyState < 2 || !video.videoWidth || !video.videoHeight) return;

      try {
        const maxEdge = 512;
        const scale = Math.min(1, maxEdge / Math.max(video.videoWidth, video.videoHeight));
        const canvas = document.createElement('canvas');
        canvas.width = Math.max(1, Math.round(video.videoWidth * scale));
        canvas.height = Math.max(1, Math.round(video.videoHeight * scale));
        const ctx = canvas.getContext('2d', { alpha: false });
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        const image = canvas.toDataURL('image/jpeg', 0.72);
        lastCameraSnapshotAt = now;
        cameraSnapshotSeq += 1;
        await room.localParticipant.publishData(
          new TextEncoder().encode(JSON.stringify({
            type: 'camera_snapshot',
            image,
            seq: cameraSnapshotSeq,
            reason,
            ts: now,
          })),
          { reliable: true }
        );
        _logStatus(`Vision snapshot sent (${reason}) #${cameraSnapshotSeq}`, 'camera_snapshot');
      } catch (err) {
        console.warn('Camera snapshot send failed:', err);
      }
    }

    // agent_image: push an image URL into the transcript panel so the user
    // can see it visually.  Fired by the agent's `send_image_to_chat` tool.
    function scrollTranscriptToBottom() {
      const log = document.getElementById('transcript-log');
      if (!log) return;
      const scroll = () => { log.scrollTop = log.scrollHeight; };
      scroll();
      // GeckoView can report the pre-layout height immediately after a DOM update.
      requestAnimationFrame(scroll);
    }

    function addImageToTranscript(url, caption) {
      if (!url) return;
      const log = document.getElementById('transcript-log');
      if (!log) return;
      const name = selectedAgent?.name || 'Agent';
      const entry = document.createElement('div');
      entry.className = 'transcript-entry speaker-agent';
      const img = document.createElement('img');
      img.src = url;
      img.alt = caption || 'Image';
      img.className = 'attachment-thumb';
      img.style.maxWidth = '280px';
      img.onerror = () => {
        img.style.display = 'none';
        const fallback = document.createElement('a');
        fallback.href = url;
        fallback.target = '_blank';
        fallback.rel = 'noopener';
        fallback.style.cssText = 'color:#818cf8;font-size:0.85rem;word-break:break-all;display:block;margin-top:4px';
        fallback.textContent = url;
        entry.appendChild(fallback);
      };
      const speaker = document.createElement('span');
      speaker.className = 'speaker agent';
      speaker.textContent = `${name}:`;
      entry.appendChild(speaker);
      entry.appendChild(img);
      if (caption) {
        const cap = document.createElement('div');
        cap.className = 'attachment-meta';
        cap.textContent = caption;
        entry.appendChild(cap);
      }
      log.appendChild(entry);
      img.addEventListener('load', scrollTranscriptToBottom, { once: true });
      scrollTranscriptToBottom();
    }

    // agent_image: push an image into the chat panel (💬 slide-up) in addition
    // to the transcript. Mirrors addImageToTranscript but targets chatLog.
    function addImageToChat(url, caption) {
      if (!url) return;
      const name = selectedAgent?.name || 'Agent';
      const row = document.createElement('div');
      row.className = 'chat-row system';
      const bubble = document.createElement('div');
      bubble.className = 'chat-bubble';
      const meta = document.createElement('div');
      meta.className = 'chat-meta';
      meta.textContent = name;
      bubble.appendChild(meta);
      const img = document.createElement('img');
      img.src = url;
      img.alt = caption || 'Image';
      img.className = 'attachment-thumb';
      img.style.cssText = 'max-width:260px;max-height:180px;border-radius:8px;margin-top:6px;display:block;cursor:pointer;';
      img.onerror = () => {
        img.style.display = 'none';
        const fallback = document.createElement('span');
        fallback.style.cssText = 'color:#6b7280;font-size:0.75rem';
        fallback.textContent = `[Image: ${url}]`;
        bubble.appendChild(fallback);
      };
      img.addEventListener('load', () => {
        chatLog.scrollTop = chatLog.scrollHeight;
      }, { once: true });
      bubble.appendChild(img);
      if (caption) {
        const cap = document.createElement('div');
        cap.className = 'attachment-meta';
        cap.style.fontSize = '0.75rem';
        cap.style.color = '#9ca3af';
        cap.textContent = caption;
        bubble.appendChild(cap);
      }
      row.appendChild(bubble);
      chatLog.appendChild(row);
      chatLog.scrollTop = chatLog.scrollHeight;
      // Images are user-visible results, not passive transcript metadata.
      // Open the sheet immediately so car/mobile users do not have to guess
      // that a new asset is hidden behind the chat button.
      setChatOpen(true);
    }

    let imageViewerPreviousFocus = null;

    function openImageViewer(url, caption = '') {
      if (!url || !imageViewer || !imageViewerImage) return;
      imageViewerPreviousFocus = document.activeElement;
      imageViewerImage.src = url;
      imageViewerImage.alt = caption || 'Image preview';
      imageViewerCaption.textContent = caption;
      imageViewer.hidden = false;
      imageViewer.inert = false;
      imageViewer.setAttribute('aria-hidden', 'false');
      imageViewerClose.focus();
    }

    function closeImageViewer() {
      if (!imageViewer || imageViewer.hidden) return;
      imageViewer.hidden = true;
      imageViewer.inert = true;
      imageViewer.setAttribute('aria-hidden', 'true');
      imageViewerImage.removeAttribute('src');
      imageViewerCaption.textContent = '';
      if (imageViewerPreviousFocus?.isConnected) imageViewerPreviousFocus.focus();
      imageViewerPreviousFocus = null;
    }

    // HD snapshot: fired only when the backend explicitly requests one via
    // a `request_hd_snapshot` data packet (triggered by the agent's
    // `view_camera_in_detail` tool). Captures the local <video> element
    // at up to 1280px @ q90; if the result exceeds ~900KB it retries at
    // 1024px @ q85 so the LiveKit data channel stays healthy.
    async function sendCameraSnapshotHD() {
      if (!visionEnabled || !room || room.state !== 'connected') return;
      const camTrack = getLocalCameraTrack();
      if (!camTrack?.mediaStreamTrack || camTrack.mediaStreamTrack.readyState !== 'live') {
        console.warn('HD snapshot: camera track not live, ignoring request');
        return;
      }
      const video = userVideo;
      if (!video || video.readyState < 2 || !video.videoWidth || !video.videoHeight) {
        console.warn('HD snapshot: video element not ready, ignoring request');
        return;
      }
      const now = Date.now();
      try {
        function encodeAt(maxEdge, quality) {
          const scale = Math.min(1, maxEdge / Math.max(video.videoWidth, video.videoHeight));
          const canvas = document.createElement('canvas');
          canvas.width = Math.max(1, Math.round(video.videoWidth * scale));
          canvas.height = Math.max(1, Math.round(video.videoHeight * scale));
          const ctx = canvas.getContext('2d', { alpha: false });
          ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
          return canvas.toDataURL('image/jpeg', quality);
        }
        let image = encodeAt(1280, 0.9);
        // Fallback if quality 0.9 @ 1280px overshoots the data-channel
        // comfort zone — better to ship a slightly smaller HD frame than
        // to lose the payload to a transport drop.
        if (image.length > 1_400_000) {
          const fallback = encodeAt(1024, 0.85);
          if (fallback.length < image.length) {
            image = fallback;
          }
        }
        cameraSnapshotSeq += 1;
        const seqNow = cameraSnapshotSeq;
        await room.localParticipant.publishData(
          new TextEncoder().encode(JSON.stringify({
            type: 'camera_snapshot',
            image,
            seq: seqNow,
            reason: 'hd_request',
            hd: true,
            ts: now,
          })),
          { reliable: true }
        );
        _logStatus(
          `HD snapshot sent #${seqNow} (~${Math.round(image.length / 1024)}KB)`,
          'camera_snapshot_hd',
        );
      } catch (err) {
        console.warn('HD camera snapshot send failed:', err);
      }
    }
    function setPrevStatus(text) {
      prevStatusText = text;
      if (prevStatusTimer) clearTimeout(prevStatusTimer);
      prevStatusTimer = setTimeout(() => { prevStatusText = ''; updateSpeakingUI(); }, 8000);
    }

    let isMuted = false;
    let userSpeaking = false;
    let agentSpeaking = false;
    let userHasSpoken = false;
    let processingTimeout = null;
    let isProcessing = false;
    let backendStatus = null;
    let currentModel = null;

    function updateModelButton() {
      const el = document.getElementById('model-btn-name');
      if (!el) return;
      // Show the short model name (strip provider prefix, e.g. "openai-codex/gpt-5.5" → "gpt-5.5")
      const short = currentModel ? currentModel.split('/').pop() : '';
      el.textContent = short;
    }

    function normalizeLevel(level) {
      const v = String(level || '').toLowerCase();
      if (['user', 'speaking', 'processing', 'idle', 'error'].includes(v)) return v;
      return '';
    }

    function formatBackendStatus(status) {
      if (!selectedAgent || !status || !status.label) return '';
      const label = String(status.label || '').trim();
      const detail = String(status.detail || '').trim();
      return detail ? `${selectedAgent.name}: ${label}, ${detail}` : `${selectedAgent.name}: ${label}`;
    }
    let currentSessionId = null;
    let chatOpen = false;
    let bootstrapAuthPromise = null;

    let visibleAgents = AGENTS;
    let defaultAgentId = 'sevro';
    let lastAgentGridSignature = '';
    let historyAgentFilter = 'all';

    function formatCommandResponse(data) {
      if (data.status) {
        return [
          `Agent: ${data.status.agent}`,
          `Model: ${data.status.model}`,
          `Session: ${data.status.sessionId}`,
          `Duration: ${data.status.callDuration}`,
          `Muted: ${data.status.muted ? 'yes' : 'no'}`,
          `Connected: ${data.status.connected ? 'yes' : 'no'}`,
        ].join('\n');
      }
      if (data.user) {
        return [
          data.user.name || 'Unknown user',
          data.user.email || '',
          `Default agent: ${data.user.defaultAgent}`,
        ].filter(Boolean).join('\n');
      }
      if (data.commands) {
        return data.commands.map(item => `${item.command}  ${item.description}`).join('\n');
      }
      return data.message || 'Done';
    }

    function addChatMessage(role, text, extra = {}) {
      const row = document.createElement('div');
      row.className = `chat-row ${role}`;

      const bubble = document.createElement('div');
      bubble.className = 'chat-bubble';

      const meta = document.createElement('div');
      meta.className = 'chat-meta';
      meta.textContent = role === 'user' ? 'You' : 'System';
      bubble.appendChild(meta);

      const body = document.createElement('div');
      body.innerHTML = renderContent(text);
      bubble.appendChild(body);

      if (extra.buttons?.length) {
        const grid = document.createElement('div');
        grid.className = 'chat-buttons';
        extra.buttons.forEach((button) => {
          const chip = document.createElement('button');
          chip.type = 'button';
          // Mark active model: value matches currentModel or current from response
          const isActive = extra.current && button.value === `/model ${extra.current}`;
          chip.className = `chat-chip${isActive ? ' chat-chip--active' : ''}`;
          if (isActive) {
            const marker = document.createElement('span');
            marker.className = 'chip-check';
            marker.textContent = '✓';
            chip.appendChild(marker);
          }
          chip.appendChild(document.createTextNode(String(button.label || button.value || 'Option')));
          if (button.description) {
            const description = document.createElement('small');
            description.textContent = String(button.description);
            chip.appendChild(description);
          }
          chip.addEventListener('click', () => runCommand(button.value));
          grid.appendChild(chip);
        });
        bubble.appendChild(grid);
      }

      row.appendChild(bubble);
      chatLog.appendChild(row);
      chatLog.scrollTop = chatLog.scrollHeight;
    }

    function setChatOpen(open) {
      chatOpen = open;
      chatPanel.classList.toggle('open', open);
      chatPanel.setAttribute('aria-hidden', open ? 'false' : 'true');
      chatPanel.inert = !open;
      chatToggle.setAttribute('aria-expanded', String(open));
      if (open) chatClose.focus();
      else chatToggle.focus();
    }

    async function applyClientAction(action) {
      if (!action?.type) return;
      if (action.type === 'disconnect') {
        if (!isConnecting) await disconnect();
        return;
      }
      if (action.type === 'new_session') {
        if (!isConnecting) await newSession(true);
        return;
      }
      if (action.type === 'switch_agent') {
        const nextAgent = visibleAgents.find(agent => agent.id === action.agent);
        if (nextAgent) {
          selectAgent(nextAgent);
          if (room && !isConnecting) {
            await disconnect();
            await new Promise(r => setTimeout(r, 300));
            await connect();
          }
        }
        return;
      }
      if (action.type === 'refresh_call') {
        currentModel = action.model || currentModel;
        updateModelButton();
        if (room && !isConnecting) {
          const sessionKey = `voice-session-${selectedAgent.id}`;
          await disconnect();
          // Do NOT restore the old session key — model switch must start a fresh
          // room so the agent picks up the new model_override from the token.
          localStorage.removeItem(sessionKey);
          await new Promise(r => setTimeout(r, 300));
          await connect();
        }
        return;
      }
      if (action.type === 'set_mute') {
        await setMuteState(Boolean(action.muted));
      }
    }

    async function runCommand(rawCommand) {
      const command = (rawCommand || '').trim();
      if (!command) return;
      addChatMessage('user', command);

      try {
        const elapsed = callStartTime ? Math.floor((Date.now() - callStartTime) / 1000) : 0;
        const res = await fetch('/api/command', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({
            command,
            agent: selectedAgent?.id,
            sessionId: currentSessionId,
            callDuration: elapsed,
            connected: Boolean(room),
            isMuted,
          }),
        });
        const data = await res.json();
        if (!res.ok) {
          addChatMessage('system', data.error || 'Command failed');
          return;
        }
        if (data.model) { currentModel = data.model; updateModelButton(); }
        addChatMessage('system', formatCommandResponse(data), { buttons: data.buttons, current: data.current });
        await applyClientAction(data.client_action);
      } catch (error) {
        console.error('Command failed:', error);
        addChatMessage('system', 'Command service unavailable. Try again.');
      }
    }

    function buildAgentGrid() {
      const signature = JSON.stringify({
        agents: visibleAgents.map(a => a.id),
        defaultAgentId,
      });

      if (signature !== lastAgentGridSignature) {
        grid.innerHTML = '';
        visibleAgents.forEach(agent => {
          const card = document.createElement('div');
          card.className = 'agent-card';
          card.dataset.agentId = agent.id;
          card.dataset.language = agent.language;
          card.setAttribute('role', 'button');
          card.setAttribute('tabindex', '0');
          card.setAttribute('aria-label', `Select ${agent.name}`);
          card.setAttribute('aria-pressed', 'false');
          card.innerHTML = `
            ${agent.hasAvatar === false
              ? `<span class="agent-avatar-fallback" aria-hidden="true">${agent.emoji}</span>`
              : `<img class="agent-avatar" src="${avatarPath(agent.id)}" alt="${agent.name}" loading="lazy" decoding="async"
                   onerror="this.hidden=true;this.nextElementSibling.hidden=false">
                 <span class="agent-avatar-fallback" hidden aria-hidden="true">${agent.emoji}</span>`}
            <div class="agent-language">${agent.language.toUpperCase()}</div>
            <div class="agent-name">${agent.name}</div>
            <div class="agent-tagline">${agent.tagline}</div>
            <div class="agent-capabilities">
              ${agent.capabilities?.vision ? '<span class="agent-capability">Vision</span>' : ''}
              ${agent.capabilities?.attachments ? '<span class="agent-capability">Files</span>' : ''}
              <span class="agent-availability">● Available</span>
            </div>
          `;
          card.addEventListener('click', () => selectAgent(agent));
          card.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              selectAgent(agent);
            }
          });
          grid.appendChild(card);
        });
        lastAgentGridSignature = signature;
      }

      const preferred = selectedAgent && visibleAgents.some(a => a.id === selectedAgent.id)
        ? selectedAgent
        : (visibleAgents.find(a => a.id === defaultAgentId) || visibleAgents[0]);
      if (preferred) selectAgent(preferred);
    }

    buildAgentGrid();
    if (localStorage.getItem('voice-first-call-tip-dismissed') === '1') firstCallTip.hidden = true;
    document.getElementById('first-call-tip-close')?.addEventListener('click', () => {
      firstCallTip.hidden = true;
      localStorage.setItem('voice-first-call-tip-dismissed', '1');
    });

    function setAuthError(message = '') {
      authError.textContent = message;
      authError.style.display = message ? 'block' : 'none';
    }

    function setUserUI(user) {
      currentUser = user;
      const name = user?.name || user?.email || '';
      const picture = user?.picture || '';
      authUser.classList.toggle('hidden', !user);
      authUserAvatar.hidden = !picture;
      accountAvatar.hidden = !picture;
      if (picture) {
        authUserAvatar.src = picture;
        accountAvatar.src = picture;
      } else {
        authUserAvatar.removeAttribute('src');
        accountAvatar.removeAttribute('src');
      }
      authUserName.textContent = name;
      accountName.textContent = name;
    }

    async function loadAgentCatalog(user) {
      try {
        const response = await fetch('/api/agents', { credentials: 'same-origin' });
        if (!response.ok) return;
        const catalog = await response.json();
        if (Array.isArray(catalog.agents) && catalog.agents.length) {
          AGENTS = catalog.agents.map(agent => ({ ...agent, hasAvatar: Boolean(agent.avatar) }));
          defaultAgentId = catalog.default || user.defaultAgent || defaultAgentId;
        }
      } catch (error) {
        console.warn('Agent catalog unavailable; using embedded fallback.', error);
      }
    }

    async function showAuthenticatedApp(user) {
      await loadAgentCatalog(user);
      // Apply per-user agent filtering
      if (user.allowedAgents && user.allowedAgents.length > 0) {
        visibleAgents = AGENTS.filter(a => user.allowedAgents.includes(a.id));
      } else {
        visibleAgents = AGENTS;
      }
      if (user.defaultAgent) {
        defaultAgentId = user.defaultAgent;
      }
      if (historyAgentFilter !== 'all' && !visibleAgents.some(a => a.id === historyAgentFilter)) {
        historyAgentFilter = 'all';
      }
      currentModel = user.modelOverride || null;
      updateModelButton();
      setUserUI(user);
      authScreen.classList.add('hidden');
      appShell.classList.remove('hidden');
      setAuthError('');
      buildAgentGrid();
      refreshMicrophoneReadiness();
      if (typeof window.refreshVoiceLockStatus === 'function') window.refreshVoiceLockStatus();
    }

    function showLogin() {
      appShell.classList.add('hidden');
      authScreen.classList.remove('hidden');
      cleanupRemoteAudio();
      if (room) {
        room.disconnect();
        room = null;
      }
    }

    function selectAgent(agent) {
      const scrollY = window.scrollY;
      selectedAgent = agent;
      window.getSelectedVoiceAgent = () => selectedAgent;
      document.querySelectorAll('.agent-card').forEach((card) => {
        const selected = card.dataset.agentId === agent.id;
        card.classList.toggle('selected', selected);
        card.setAttribute('aria-pressed', String(selected));
      });
      if (currentUser) {
        statusEl.textContent = `Ready — ${agent.name}`;
        statusEl.className = 'status status-disconnected';
      }
      if (selectedAgentSummary) selectedAgentSummary.textContent = `${agent.name} — ${agent.tagline || 'Ready to help.'}`;
      if (attachmentCapability) attachmentCapability.textContent = agent.capabilities?.attachments === false ? 'Not supported by this agent' : 'Available after the call starts';
      updateSessionIndicator();
      window.scrollTo(0, scrollY);
    }

    function updateSessionIndicator() {
      if (!selectedAgent) return;
      const sid = localStorage.getItem(`voice-session-${selectedAgent.id}`);
      sessionIndicator.innerHTML = sid
        ? `<span class="active">● Continuing session</span>`
        : 'New session';
    }

    function clearSession() {
      if (!selectedAgent) return;
      localStorage.removeItem(`voice-session-${selectedAgent.id}`);
      currentSessionId = null;
      updateSessionIndicator();
      setStatus(`Ready — ${selectedAgent.name} (new session)`, 'disconnected');
    }

    function setStatus(text, cls) {
      statusEl.textContent = text;
      statusEl.className = `status status-${cls}`;
    }

    function setCallState(state, label, detail) {
      if (!callStateStrip) return;
      callStateStrip.dataset.state = state;
      callStateLabel.textContent = label;
      callStateDetail.textContent = detail || '';
    }

    function enterProcessing() {
      if (isProcessing) return;
      isProcessing = true;
      if (!backendStatus) {
        backendStatus = { code: 'frontend_processing', label: 'Processing', detail: 'Preparing your message for the agent', level: 'processing' };
      }
      updateSpeakingUI();
    }

    function exitProcessing() {
      isProcessing = false;
      if (processingTimeout) { clearTimeout(processingTimeout); processingTimeout = null; }
      if (backendStatus && normalizeLevel(backendStatus.level) === 'processing') {
        backendStatus = null;
      }
    }

    function onUserSpeakingChanged(speaking) {
      userSpeaking = speaking;
      if (speaking) {
        userHasSpoken = true;
        exitProcessing();
        // Mobile browsers have repeatedly served stale remote video frames to
        // the backend while the local preview is fresh. Send a tiny one-turn
        // still from the preview whenever the user starts speaking.
        sendCameraSnapshot('speech_start');
      } else if (userHasSpoken && !agentSpeaking) {
        sendCameraSnapshot('speech_end');
        if (processingTimeout) clearTimeout(processingTimeout);
        processingTimeout = setTimeout(() => {
          if (!userSpeaking && !agentSpeaking && userHasSpoken) {
            backendStatus = {
              code: 'frontend_processing',
              label: 'Processing',
              detail: 'Detecting end of speech and preparing STT/LLM handoff',
              level: 'processing',
            };
            enterProcessing();
          }
        }, 400);
      }
      updateSpeakingUI();
    }

    function onAgentSpeakingChanged(speaking) {
      agentSpeaking = speaking;
      if (speaking) {
        exitProcessing();
        userHasSpoken = false;
      } else {
        // Agent just stopped speaking — remember it
        setPrevStatus(`${selectedAgent?.name || 'Agent'} spoke`);
      }
      updateSpeakingUI();
    }

    function monitorAgentState(participant) {
      const s = participant.attributes?.['lk.agent.state'];
      if (s) handleAgentStateChange(s);
    }

    // ── Connection / TTS issue banner ──────────────────────────────────────
    let _stuckThinkingTimer = null;
    let voiceRecoveryMessage = '';
    const _connBanner = () => document.getElementById('connectionBanner');
    const _connBannerText = () => document.getElementById('connBannerText');

    function showConnectionBanner(msg, isError = false) {
      const el = _connBanner(); const tx = _connBannerText();
      if (!el || !tx) return;
      tx.textContent = msg;
      el.classList.toggle('error', isError);
      el.classList.add('visible');
    }
    document.getElementById('voiceRecoveryBtn').addEventListener('click', async () => {
      const button = document.getElementById('voiceRecoveryBtn');
      button.disabled = true;
      try {
        voiceRecoveryMessage = '';
        await disconnect();
        await connect();
        hideConnectionBanner();
      } finally {
        button.disabled = false;
      }
    });

    function hideConnectionBanner() {
      document.getElementById('voiceRecoveryBtn').hidden = true;
      const el = _connBanner(); if (el) el.classList.remove('visible');
      clearTimeout(_stuckThinkingTimer); _stuckThinkingTimer = null;
    }

    // Wire up close button (safe to call before DOM ready — button appears after body)
    document.addEventListener('DOMContentLoaded', () => {
      document.getElementById('connBannerClose')?.addEventListener('click', hideConnectionBanner);
    });
    // Also wire immediately in case DOMContentLoaded already fired
    document.getElementById('connBannerClose')?.addEventListener('click', hideConnectionBanner);

    function handleAgentStateChange(state) {
      console.log('[voice] agent state:', state);
      _logStatus(`AgentState: ${state}`, 'handleAgentStateChange');
      if (state === 'thinking') {
        if (!backendStatus || !String(backendStatus.code || '').startsWith('tool_')) {
          backendStatus = {
            code: 'llm_call',
            label: 'Thinking',
            detail: 'LLM call in flight',
            level: 'processing',
          };
        }
        enterProcessing();
        updateSpeakingUI();
        // Start stuck-thinking watchdog — if agent doesn't speak within 14s, show banner
        clearTimeout(_stuckThinkingTimer);
        _stuckThinkingTimer = setTimeout(() => {
          showConnectionBanner('Still working on it… the voice service may be a bit slow right now.');
        }, 14000);
      } else if (state === 'speaking') {
        hideConnectionBanner(); // recovered — dismiss any banner
        setPrevStatus(formatBackendStatus(backendStatus) || prevStatusText);
        exitProcessing();
        agentSpeaking = true;
        backendStatus = {
          code: 'agent_speaking',
          label: 'Speaking',
          detail: 'Reply audio is playing',
          level: 'speaking',
        };
        updateSpeakingUI();
      } else if (state === 'listening') {
        hideConnectionBanner(); // recovered — dismiss any banner
        exitProcessing();
        agentSpeaking = false;
        backendStatus = {
          code: 'agent_listening',
          label: 'Waiting for you',
          detail: 'Mic open, ready for your next turn',
          level: 'idle',
        };
        updateSpeakingUI();
      }
    }

    // ── Status event logger ──
    const _statusLog = [];
    let _lastStatusText = '';
    let _lastStatusTime = 0;
    function _logStatus(text, source) {
      const now = Date.now();
      if (_lastStatusText && _lastStatusTime) {
        const dur = now - _lastStatusTime;
        _statusLog.push({ t: _lastStatusTime, text: _lastStatusText, dur, source });
      }
      _lastStatusText = text;
      _lastStatusTime = now;
      // Keep last 200 entries
      if (_statusLog.length > 200) _statusLog.splice(0, _statusLog.length - 200);
    }
    // Privacy-safe experience metrics: names and durations only. No transcript,
    // filenames, credentials, or media data are included.
    try {
      const vitalObserver = new PerformanceObserver((list) => {
        for (const entry of list.getEntries()) {
          if (entry.entryType === 'paint' || entry.entryType === 'largest-contentful-paint') {
            _logStatus(`metric:${entry.name}:${Math.round(entry.startTime)}ms`, 'web-vital');
          } else if (entry.entryType === 'layout-shift' && !entry.hadRecentInput) {
            _logStatus(`metric:layout-shift:${Number(entry.value).toFixed(4)}`, 'web-vital');
          }
        }
      });
      for (const type of ['paint', 'largest-contentful-paint', 'layout-shift']) {
        try { vitalObserver.observe({ type, buffered: true }); } catch { /* unsupported metric */ }
      }
    } catch { /* PerformanceObserver unavailable */ }
    // Expose for debugging: call window.__statusLog() in console
    window.__statusLog = () => {
      const log = [..._statusLog];
      if (_lastStatusText) log.push({ t: _lastStatusTime, text: _lastStatusText, dur: Date.now() - _lastStatusTime, source: 'current' });
      return log.map(e => {
        const ts = new Date(e.t).toISOString().slice(11, 23);
        return `${ts} [${String(e.dur).padStart(5)}ms] ${e.text}`;
      }).join('\n');
    };
    window.__statusLogRaw = () => {
      const log = [..._statusLog];
      if (_lastStatusText) log.push({ t: _lastStatusTime, text: _lastStatusText, dur: Date.now() - _lastStatusTime, source: 'current' });
      return log;
    };

    // Flush status log to backend
    let _statusLogFlushed = 0;
    async function _flushStatusLog() {
      if (_statusLog.length <= _statusLogFlushed) return;
      const entries = _statusLog.slice(_statusLogFlushed);
      _statusLogFlushed = _statusLog.length;
      try {
        await fetch('/api/status-log', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({
            agent: selectedAgent?.id || 'unknown',
            session: currentSessionId || 'unknown',
            entries,
          }),
        });
      } catch (e) {
        console.warn('Status log flush failed:', e);
      }
    }
    // Flush every 30s while connected
    setInterval(() => { if (room) _flushStatusLog(); }, 30000);

    function updateSpeakingUI() {
      userRing.className = 'participant-ring ' + (userSpeaking ? 'speaking' : 'idle');
      userLabel.className = 'participant-label' + (userSpeaking ? ' speaking' : '');

      if (agentSpeaking) {
        agentRing.className = 'participant-ring speaking';
        agentLabel.className = 'participant-label speaking';
      } else if (isProcessing) {
        agentRing.className = 'participant-ring processing';
        agentLabel.className = 'participant-label processing';
      } else if (userSpeaking) {
        agentRing.className = 'participant-ring listening';
        agentLabel.className = 'participant-label listening';
      } else {
        agentRing.className = 'participant-ring idle';
        agentLabel.className = 'participant-label';
      }

      if (userSpeaking) {
        waveform.className = 'waveform user-active';
      } else if (agentSpeaking) {
        waveform.className = 'waveform agent-active';
      } else if (isProcessing) {
        waveform.className = 'waveform processing';
      } else {
        waveform.className = 'waveform';
      }

      if (userSpeaking && agentSpeaking) {
        setCallState('speaking', 'Conversation active', 'You and the agent are speaking.');
        speakingStatus.textContent = 'Both speaking';
        speakingStatus.className = 'speaking-status user-talking';
        _logStatus('Both speaking', 'updateSpeakingUI');
      } else if (userSpeaking) {
        setCallState('listening', 'Listening', 'Your microphone is sending audio.');
        speakingStatus.textContent = '🎤 You\'re speaking...';
        speakingStatus.className = 'speaking-status user-talking';
        _logStatus('User speaking', 'updateSpeakingUI');
      } else if (agentSpeaking) {
        setCallState('speaking', 'Speaking', `${selectedAgent.name} is responding.`);
        speakingStatus.textContent = `${selectedAgent.emoji} ${selectedAgent.name} is speaking...`;
        speakingStatus.className = 'speaking-status agent-talking';
        _logStatus(`Agent speaking`, 'updateSpeakingUI');
      } else if (isProcessing) {
        setCallState('processing', 'Thinking', 'Preparing the response…');
        const label = (backendStatus ? formatBackendStatus(backendStatus) : null) || 'Processing your message...';
        speakingStatus.innerHTML = escapeHtml(label) + '<span class="processing-dots"></span>';
        speakingStatus.className = 'speaking-status processing';
        _logStatus(`Processing: ${label}`, 'updateSpeakingUI');
      } else {
        setCallState('connected', 'Ready', 'Speak when you are ready.');
        const idleStatus = backendStatus && normalizeLevel(backendStatus.level) === 'idle' ? backendStatus : null;
        let html = idleStatus
          ? escapeHtml(formatBackendStatus(idleStatus) || 'Waiting for you...')
          : 'Waiting for you...';
        if (prevStatusText && !idleStatus) {
          html += ` <span style="color:#666;font-size:0.85em">(${escapeHtml(prevStatusText.replace(/\.\.\.$/,''))})</span>`;
        }
        speakingStatus.innerHTML = html;
        speakingStatus.className = 'speaking-status';
        _logStatus(`Idle: ${idleStatus?.label || 'Waiting for you'}`, 'updateSpeakingUI');
      }
    }

    function startTimer() {
      callStartTime = Date.now();
      timerInterval = setInterval(() => {
        const elapsed = Math.floor((Date.now() - callStartTime) / 1000);
        const min = String(Math.floor(elapsed / 60)).padStart(2, '0');
        const sec = String(elapsed % 60).padStart(2, '0');
        callTimer.textContent = `${min}:${sec}`;
      }, 1000);
    }

    function stopTimer() {
      if (timerInterval) clearInterval(timerInterval);
      timerInterval = null;
      callTimer.textContent = '00:00';
    }

    async function getToken(agentId) {
      const sessionKey = `voice-session-${agentId}`;
      let sessionId = localStorage.getItem(sessionKey);
      let url = `/api/token?agent=${encodeURIComponent(agentId)}`;
      if (sessionId) url += `&session=${encodeURIComponent(sessionId)}`;
      const connMethod = connectionMethodSelect ? connectionMethodSelect.value : 'default';
      if (connMethod && connMethod !== 'default') {
        url += `&connection_method=${encodeURIComponent(connMethod)}`;
      }
      const sttProvider = sttProviderSelect ? sttProviderSelect.value : 'local';
      url += `&stt_provider=${encodeURIComponent(sttProvider)}`;
      const res = await fetch(url, { credentials: 'same-origin' });
      if (res.status === 401) {
        showLogin();
        throw new Error('Your login expired. Sign in again.');
      }
      if (!res.ok) throw new Error(`Token request failed: ${res.status}`);
      const data = await res.json();
      const parts = data.room.split('-');
      localStorage.setItem(sessionKey, parts.slice(2).join('-'));
      currentSessionId = data.sessionId || parts.slice(2).join('-');
      currentModel = data.model || currentModel;
      updateModelButton();
      // Stash ice servers for use in connect()
      window.__lkIceServers = data.iceServers || null;
      // Vision capability from agent config
      visionCapable = !!data.vision;
      visionBtn.disabled = !visionCapable;
      visionBtn.title = visionCapable ? 'Toggle camera vision' : 'Vision not available for this agent';
      if (!visionCapable) {
        availableVideoInputs = [];
        renderCameraSelect();
      }
      return data.token;
    }

    function cleanupRemoteAudio() {
      for (const el of audioElements.values()) {
        detachAgentAudioAnalyzer(el);
        el.pause();
        el.srcObject = null;
        el.remove();
      }
      audioElements = new Map();
      audioAnalyzers = new Map();
      resetAgentMouth();
      audioBtn.style.display = 'none';
      audioHint.classList.remove('visible');
    }

    async function startRoomAudio() {
      if (!room) return;
      try {
        if (agentAudioContext?.state === 'suspended') {
          await agentAudioContext.resume();
        }
        await room.startAudio();
        audioBtn.style.display = 'none';
        audioHint.classList.remove('visible');
      } catch {
        audioBtn.style.display = 'block';
        audioHint.classList.add('visible');
      }
    }

    function ensureAgentAudioContext() {
      const AudioCtx = window.AudioContext || window.webkitAudioContext;
      if (!AudioCtx) return null;
      if (!agentAudioContext) agentAudioContext = new AudioCtx();
      return agentAudioContext;
    }

    function resetAgentMouth() {
      if (!agentAvatarWrap) return;
      agentAvatarWrap.style.setProperty('--avatar-pulse', '0');
      agentAvatarWrap.style.setProperty('--talk-bob', '0');
    }

    function startAgentMouthLoop() {
      if (agentMouthRaf) return;

      const tick = () => {
        let level = 0;
        if (agentSpeaking && audioAnalyzers.size) {
          for (const { analyser, data } of audioAnalyzers.values()) {
            analyser.getByteTimeDomainData(data);
            let sum = 0;
            for (let i = 0; i < data.length; i++) {
              const centered = (data[i] - 128) / 128;
              sum += centered * centered;
            }
            const rms = Math.sqrt(sum / data.length);
            level = Math.max(level, Math.min(1, Math.max(0, (rms - 0.012) * 9)));
          }
        }

        if (agentAvatarWrap) {
          // Whole-avatar audio-reactive motion (option 1): RMS drives a subtle
          // scale-pulse + head-bob + glow-ring intensity. No fake mouth overlay
          // — works uniformly for all 8 agent avatars without per-agent CSS.
          const pulse = agentSpeaking ? level : 0;
          agentAvatarWrap.style.setProperty('--avatar-pulse', pulse.toFixed(3));
          agentAvatarWrap.style.setProperty('--talk-bob', Math.min(1, pulse * 0.8).toFixed(3));
        }

        agentMouthRaf = requestAnimationFrame(tick);
      };

      agentMouthRaf = requestAnimationFrame(tick);
    }

    function attachAgentAudioAnalyzer(audioEl, track) {
      try {
        if (audioAnalyzers.has(audioEl)) return;
        const ctx = ensureAgentAudioContext();
        if (!ctx) return;
        // LiveKit attaches via srcObject = MediaStream. createMediaElementSource
        // returns silent samples for MediaStream-fed elements (well-known Web
        // Audio quirk), so the analyser reads RMS=0 and the mouth never opens.
        // Use the underlying MediaStreamTrack instead — createMediaStreamSource
        // taps the live audio without disturbing playback.
        const mst = track?.mediaStreamTrack
          || (track?.mediaStream?.getAudioTracks?.()[0])
          || (audioEl.srcObject?.getAudioTracks?.()[0]);
        if (!mst) {
          console.warn('Agent mouth animation: no MediaStreamTrack available');
          return;
        }
        const stream = new MediaStream([mst]);
        const source = ctx.createMediaStreamSource(stream);
        const analyser = ctx.createAnalyser();
        analyser.fftSize = 256;
        analyser.smoothingTimeConstant = 0.35;
        source.connect(analyser);
        // Do NOT connect to ctx.destination — the <audio> element already
        // plays the track, so wiring the graph to the speakers would double it.
        audioAnalyzers.set(audioEl, { source, analyser, stream, data: new Uint8Array(analyser.fftSize) });
        startAgentMouthLoop();
        if (ctx.state === 'suspended') {
          ctx.resume().catch((e) => console.warn('Agent audio ctx resume failed:', e));
        }
      } catch (err) {
        // Non-fatal: some browser/audio-policy combinations reject Web Audio
        // routing for media elements. The call audio still works; only the
        // fake lip-sync falls back to ring animation.
        console.warn('Agent mouth animation unavailable:', err);
      }
    }

    function detachAgentAudioAnalyzer(audioEl) {
      const entry = audioAnalyzers.get(audioEl);
      if (!entry) return;
      try { entry.source.disconnect(); } catch { /* best effort */ }
      try { entry.analyser.disconnect(); } catch { /* best effort */ }
      audioAnalyzers.delete(audioEl);
      if (!audioAnalyzers.size) resetAgentMouth();
    }

    async function requestMicrophoneAccess() {
      if (!navigator.mediaDevices?.getUserMedia) {
        throw new Error('This browser does not support microphone access');
      }

      const stream = await navigator.mediaDevices.getUserMedia({
        audio: MICROPHONE_CAPTURE_OPTIONS,
      });
      for (const track of stream.getTracks()) {
        track.stop();
      }
    }

    function attachRemoteTrack(track, publication, participant) {
      if (track.kind !== 'audio') return;
      const audioEl = track.attach();
      audioEl.autoplay = true;
      audioEl.playsInline = true;
      audioEl.dataset.sid = publication.trackSid || publication.sid || track.sid || participant.identity;
      remoteAudioContainer.appendChild(audioEl);
      audioElements.set(audioEl.dataset.sid, audioEl);
      attachAgentAudioAnalyzer(audioEl, track);
      startRoomAudio();
    }

    function detachRemoteTrack(track) {
      if (track.kind !== 'audio') return;
      for (const el of track.detach()) {
        const sid = el.dataset.sid;
        detachAgentAudioAnalyzer(el);
        if (sid) audioElements.delete(sid);
        el.remove();
      }
    }

    // Previous transcript loading removed — all content comes from backend polling

    function showCallScreen() {
      selectScreen.style.display = 'none';
      callScreen.classList.add('visible');
      chatToggle.classList.add('visible');
      const hasAvatar = selectedAgent.hasAvatar !== false;
      callAvatar.hidden = !hasAvatar;
      callAvatarFallback.hidden = hasAvatar;
      callAvatarFallback.textContent = selectedAgent.emoji;
      if (hasAvatar) {
        callAvatar.src = avatarPath(selectedAgent.id);
        callAvatar.alt = selectedAgent.name;
        callAvatar.onerror = () => {
          callAvatar.hidden = true;
          callAvatarFallback.hidden = false;
        };
      } else {
        callAvatar.removeAttribute('src');
        callAvatar.alt = '';
      }
      agentLabel.textContent = selectedAgent.name;
      speakingStatus.textContent = 'Connecting...';
      setCallState('connecting', 'Connecting', 'Preparing the secure voice channel…');
      speakingStatus.className = 'speaking-status';
      document.getElementById('transcript-log').innerHTML = ''; // cleared on fresh call; history reloaded from backend
      // Show "resuming" vs "new session" based on whether localStorage has a session ID
      const _resumingSession = selectedAgent && !!localStorage.getItem(`voice-session-${selectedAgent.id}`);
      const _sysLabel = _resumingSession ? '🔄 Resuming session...' : '✨ New session started';
      const sysTrans = document.createElement('div');
      sysTrans.className = 'transcript-entry';
      sysTrans.style.cssText = 'text-align:center;opacity:0.45;font-size:0.8rem;padding:12px 0;';
      sysTrans.textContent = _sysLabel;
      document.getElementById('transcript-log').appendChild(sysTrans);
      document.getElementById('chat-log').innerHTML = ''; // clear chat panel too
      // Add matching system message to chat too
      const sysRow = document.createElement('div');
      sysRow.className = 'chat-row system';
      sysRow.innerHTML = `<div class="chat-bubble system" style="text-align:center;opacity:0.5;font-size:0.85rem;margin:8px auto;">${_sysLabel}</div>`;
      document.getElementById('chat-log').appendChild(sysRow);
      transcriptHistoryLoaded = false;
      userSpeaking = false;
      agentSpeaking = false;
      isProcessing = false;
      backendStatus = null;
      userHasSpoken = false;
      updateSpeakingUI();
    }

    function showSelectScreen() {
      callScreen.classList.remove('visible');
      selectScreen.style.display = '';
      chatToggle.classList.remove('visible');
      setChatOpen(false);
      stopTimer();
      isMuted = false;
      muteBtn.classList.remove('muted');
      muteBtn.textContent = '🎤';
      muteLabel.textContent = 'Mute';
      // Reset vision state
      visionEnabled = false;
      visionBtn.setAttribute('aria-pressed', 'false');
      visionBtn.setAttribute('aria-label', 'Enable camera vision');
      muteBtn.setAttribute('aria-pressed', 'false');
      muteBtn.setAttribute('aria-label', 'Mute microphone');
      visionCapable = false;
      visionBtn.classList.remove('active');
      visionBtn.disabled = true;
      visionBtn.textContent = '👁';
      visionLabel.textContent = 'Vision';
      availableVideoInputs = [];
      renderCameraSelect();
      clearLocalCameraPreview();
    }

    async function connect() {
      if (!selectedAgent || isConnecting) return;

      isConnecting = true;
      const connectStartedAt = performance.now();
      const agentId = selectedAgent.id;
      resetVoiceUiState();
      setStatus('Requesting microphone...', 'connecting');
      connectBtn.disabled = true;
      showCallScreen();

      try {
        await requestMicrophoneAccess();
        setStatus('Connecting...', 'connecting');

        const token = await getToken(agentId);
        if (visionCapable) await refreshCameraDevices();
        room = new Room();

        room.on(RoomEvent.TrackSubscribed, attachRemoteTrack);
        room.on(RoomEvent.TrackUnsubscribed, detachRemoteTrack);

        room.on(RoomEvent.AudioPlaybackStatusChanged, () => {
          const blocked = room.canPlaybackAudio === false;
          audioBtn.style.display = blocked ? 'block' : 'none';
          audioHint.classList.toggle('visible', blocked);
        });

        room.on(RoomEvent.LocalTrackPublished, () => {
          _logStatus('Local track published', 'livekit');
          room.localParticipant.on(ParticipantEvent.IsSpeakingChanged, (speaking) => {
            onUserSpeakingChanged(speaking);
          });
        });

        room.on(RoomEvent.ParticipantConnected, (participant) => {
          participant.on(ParticipantEvent.IsSpeakingChanged, (speaking) => {
            onAgentSpeakingChanged(speaking);
          });
        });

        room.on(RoomEvent.Connected, () => {
          _logStatus(`metric:call-connect:${Math.round(performance.now() - connectStartedAt)}ms`, 'journey');
          isConnecting = false;
          speakingStatus.textContent = 'Connected — speak!';
          setCallState('connected', 'Ready', 'Speak when you are ready.');
          setStatus(`Connected — ${selectedAgent.name}`, 'connected');
          connectBtn.disabled = false;
          startTimer();

          for (const p of room.remoteParticipants.values()) {
            p.on(ParticipantEvent.IsSpeakingChanged, (speaking) => {
              onAgentSpeakingChanged(speaking);
            });
            // Wire up agent state from participant attributes
            monitorAgentState(p);
          }
        });

        room.on(RoomEvent.ParticipantAttributesChanged, (changedAttributes, participant) => {
          if (participant.isLocal) return;
          const agentState = changedAttributes['lk.agent.state'] || participant.attributes?.['lk.agent.state'];
          if (agentState) handleAgentStateChange(agentState);
        });

        room.on(RoomEvent.ActiveSpeakersChanged, (speakers) => {
          const localId = room.localParticipant.identity;
          let newUser = false;
          let newAgent = false;
          for (const s of speakers) {
            if (s.identity === localId) newUser = true;
            else newAgent = true;
          }
          if (newUser !== userSpeaking) onUserSpeakingChanged(newUser);
          if (newAgent !== agentSpeaking) onAgentSpeakingChanged(newAgent);
        });

        // Client-side transcript rendering from LiveKit events
        room.on(RoomEvent.TranscriptionReceived, (segments, participant) => {
          const log = document.getElementById('transcript-log');
          if (!log) return;

          const isLocal = participant?.isLocal;

          for (const seg of segments) {
            const text = seg.text?.trim();
            if (!text) continue;

            const isFinal = seg.final !== false;
            if (isLocal) {
              sendCameraSnapshot(isFinal ? 'transcript_final' : 'transcript_interim');
            }

            let entryId = `transcript-${seg.id || Date.now()}`;
            let entry = document.getElementById(entryId);

            const speakerClass = isLocal ? 'user' : 'agent';

            if (!entry) {
              entry = document.createElement('div');
              entry.className = `transcript-entry speaker-${speakerClass}`;
              entry.id = entryId;
              log.appendChild(entry);
            }
            const speakerName = isLocal ? 'You' : (selectedAgent?.name || 'Agent');
            const textClass = isFinal ? 'text' : 'text interim';

            entry.innerHTML = `<span class="speaker ${speakerClass}">${speakerName}:</span><span class="${textClass}">${isFinal ? renderContent(text) : escapeHtml(text)}</span>`;

            scrollTranscriptToBottom();
          }
        });
        startTranscriptPolling();

        room.on(RoomEvent.Disconnected, () => {
          isConnecting = false;
          _flushStatusLog(); // Persist status log before cleanup
          stopTranscriptPolling();
          setStatus(`Ready — ${selectedAgent.name}`, 'disconnected');
          connectBtn.textContent = 'Connect';
          connectBtn.className = 'btn btn-connect';
          connectBtn.disabled = false;
          cleanupRemoteAudio();
          showSelectScreen();
          userSpeaking = false;
          agentSpeaking = false;
          exitProcessing();
          currentSessionId = null;
          room = null;
          if (voiceRecoveryMessage) {
            showConnectionBanner(voiceRecoveryMessage, true);
            document.getElementById('voiceRecoveryBtn').hidden = false;
          }
        });

        room.on(RoomEvent.ConnectionStateChanged, (state) => {
          _logStatus(`ConnectionState: ${state}`, 'livekit');
          if (state === ConnectionState.Reconnecting) {
            speakingStatus.textContent = 'Reconnecting...';
            setCallState('connecting', 'Reconnecting', 'Your transcript is safe while the voice channel recovers.');
            setStatus('Reconnecting...', 'connecting');
            showConnectionBanner('Connection interrupted — trying to reconnect…');
          } else if (state === ConnectionState.Connected) {
            speakingStatus.textContent = 'Connected — speak!';
            setCallState('connected', 'Ready', 'Voice connection restored.');
            hideConnectionBanner();
          } else if (state === ConnectionState.Disconnected && !voiceRecoveryMessage) {
            hideConnectionBanner();
          }
        });

        // Inbound data-channel listener. Currently used by the backend to
        // ask the browser for an HD camera frame (view_camera_in_detail
        // tool). Wrapped in try/catch so a malformed packet from any other
        // sender can't kill the LiveKit room.
        room.on(RoomEvent.DataReceived, (payload, participant) => {
          let msg;
          try {
            msg = JSON.parse(new TextDecoder().decode(payload));
          } catch {
            return;
          }
          if (!msg || typeof msg.type !== 'string') return;
          if (msg.type === 'request_hd_snapshot') {
            sendCameraSnapshotHD().catch((err) => {
              console.warn('HD snapshot dispatch failed:', err);
            });
          } else if (msg.type === 'agent_image') {
            addImageToTranscript(String(msg.url || ''), String(msg.caption || ''));
            addImageToChat(String(msg.url || ''), String(msg.caption || ''));
          } else if (msg.type === 'stt_unavailable') {
            // Accept recovery control only from the server's agent participant.
            if (!participant?.isAgent) return;
            if (msg.exhausted) voiceRecoveryMessage = String(msg.message || 'Speech recognition unavailable.');
            showConnectionBanner(String(msg.message || 'Speech recognition unavailable.'), true);
            // The broken room is closed after the spoken notice; reconnect
            // becomes available on Disconnected, once a fresh job can start.
            document.getElementById('voiceRecoveryBtn').hidden = true;
          } else if (msg.type === 'connection_issue') {
            // Backend signals a TTS/service error — show banner, auto-dismiss after 12s
            const errMsg = String(msg.message || 'Something went wrong on the voice side — will retry automatically.');
            showConnectionBanner(errMsg, true);
            setTimeout(() => hideConnectionBanner(), 12000);
          } else if (msg.type === 'connection_recovered') {
            hideConnectionBanner();
          }
        });

        // Provide coturn on AWS as TURN fallback — don't force relay so direct/STUN
        // paths still work on home WiFi (TCP 3478 on coturn is blocked, relay-only mode
        // causes timeout before UDP TURN gets tried)
        const connectOpts = window.__lkIceServers ? {
          rtcConfig: {
            iceServers: window.__lkIceServers,
          }
        } : {};
        await room.connect(LIVEKIT_URL, token, connectOpts);
        await startRoomAudio();
        await room.localParticipant.setMicrophoneEnabled(true, MICROPHONE_CAPTURE_OPTIONS);
        const micTrack = await waitForLocalMicrophoneTrack();
        if (!micTrack?.mediaStreamTrack) throw new Error('Microphone did not publish an audio track');
        _logStatus('Microphone track live', 'livekit');
      } catch (err) {
        isConnecting = false;
        console.error('Connection failed:', err);
        let message = err?.message || 'Connection failed';
        if (err?.name === 'NotAllowedError' || err?.name === 'PermissionDeniedError') {
          message = 'Microphone permission was blocked. Allow mic access in the browser and try again.';
        } else if (err?.name === 'NotFoundError' || err?.name === 'DevicesNotFoundError') {
          message = 'No microphone was found on this device.';
        }
        setStatus(`Error: ${message}`, 'error');
        connectBtn.disabled = false;
        const failedRoom = room;
        room = null;
        if (failedRoom) {
          try { await failedRoom.disconnect(); } catch { /* best effort cleanup */ }
        }
        stopTranscriptPolling();
        cleanupRemoteAudio();
        showSelectScreen();
      }
    }

    function resetVoiceUiState() {
      stopTranscriptPolling();
      cleanupRemoteAudio();
      userSpeaking = false;
      agentSpeaking = false;
      userHasSpoken = false;
      currentSessionId = null;
      backendStatus = null;
      prevStatusText = '';
      exitProcessing();
      callStartTime = null;
      stopTimer();
      // Reset vision — camera must never persist across sessions
      visionEnabled = false;
      visionBtn.setAttribute('aria-pressed', 'false');
      visionBtn.setAttribute('aria-label', 'Enable camera vision');
      muteBtn.setAttribute('aria-pressed', 'false');
      muteBtn.setAttribute('aria-label', 'Mute microphone');
      cameraSnapshotSeq = 0;
      lastCameraSnapshotAt = 0;
      clearLocalCameraPreview();
    }

    async function disconnect() {
      const activeRoom = room;
      room = null;
      resetVoiceUiState();
      if (activeRoom) await activeRoom.disconnect();
    }

    function abandonLiveKitRoomForPageLifecycle(reason) {
      const activeRoom = room;
      if (!activeRoom) return;
      _logStatus(`Page lifecycle cleanup: ${reason}`, 'page_lifecycle');
      _flushStatusLog();
      room = null;
      try { activeRoom.localParticipant?.setCameraEnabled?.(false); } catch { /* best effort */ }
      try { activeRoom.localParticipant?.setMicrophoneEnabled?.(false); } catch { /* best effort */ }
      try { activeRoom.disconnect(); } catch { /* best effort */ }
      resetVoiceUiState();
      showSelectScreen();
    }

    window.addEventListener('pagehide', () => abandonLiveKitRoomForPageLifecycle('pagehide'));
    window.addEventListener('beforeunload', () => abandonLiveKitRoomForPageLifecycle('beforeunload'));
    window.addEventListener('pageshow', (event) => {
      // iOS/Android can restore the page from BFCache with JS objects alive but
      // WebRTC tracks dead. Never pretend that stale Room object is usable.
      if (event.persisted || (room && room.state !== 'connected')) {
        abandonLiveKitRoomForPageLifecycle('pageshow-stale-room');
      }
    });
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') _flushStatusLog();
    });

    async function newSession(shouldReconnect = true) {
      if (!selectedAgent) return;
      const agent = selectedAgent;
      await disconnect();
      await new Promise(r => setTimeout(r, 500));
      localStorage.removeItem(`voice-session-${agent.id}`);
      currentSessionId = null;
      updateSessionIndicator();
      if (shouldReconnect) connect();
    }

    async function handleGoogleCredential(response) {
      setAuthError('');
      try {
        const res = await fetch('/api/auth/google', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ token: response.credential }),
        });
        const data = await res.json();
        if (!res.ok) {
          throw new Error(data.error || 'Access denied');
        }
        await bootstrapAuth();
      } catch (error) {
        setAuthError(error.message || 'Sign-in failed');
      }
    }

    let _gsiRetries = 0;
    function initGoogleSignIn(clientId) {
      if (!clientId) {
        setAuthError('Google sign-in is not configured on the server.');
        return;
      }

      if (!window.google?.accounts?.id) {
        _gsiRetries++;
        if (_gsiRetries < 50) { // ~10 seconds
          setTimeout(() => initGoogleSignIn(clientId), 200);
          return;
        }
        // Fallback: show a manual sign-in link
        console.warn('Google GSI script failed to load after 10s, showing fallback');
        googleSigninSlot.innerHTML = '';
        const reloadButton = document.createElement('button');
        reloadButton.type = 'button';
        reloadButton.style.cssText = 'padding:12px 24px;font-size:1rem;border-radius:8px;border:1px solid #555;background:#1a1a2e;color:#fff;cursor:pointer';
        reloadButton.textContent = '🔄 Reload to sign in with Google';
        reloadButton.addEventListener('click', () => window.location.reload());
        googleSigninSlot.appendChild(reloadButton);
        return;
      }

      // GSI object exists but may not be fully ready — wait a tick on first hit
      if (_gsiRetries > 0) {
        _gsiRetries = 0;
        setTimeout(() => initGoogleSignIn(clientId), 100);
        return;
      }

      googleSigninSlot.innerHTML = '';
      window.google.accounts.id.initialize({
        client_id: clientId,
        callback: handleGoogleCredential,
        auto_select: false,
        ux_mode: 'popup',
        use_fedcm_for_prompt: true,
      });
      try {
        window.google.accounts.id.renderButton(googleSigninSlot, {
          theme: 'filled_black',
          size: 'large',
          type: 'standard',
          shape: 'pill',
          text: 'signin_with',
          width: 280,
        });
      } catch (error) {
        console.error('GSI renderButton failed', error);
        setAuthError(`Google sign-in render failed: ${error?.message || error}`);
      }

      // Safety net: if slot still empty after 3s, show actionable fallback
      let _safetyFired = false;
      setTimeout(() => {
        if (!googleSigninSlot.innerHTML.trim() && !_safetyFired) {
          _safetyFired = true;
          console.warn('GSI renderButton produced empty slot, showing fallback');
          const dbg = document.createElement('div');
          dbg.style.cssText = 'color:#f66;font-size:0.75rem;margin-top:12px;white-space:pre-wrap;';
          dbg.textContent = `GSI debug\ngoogle=${!!window.google?.accounts?.id}\norigin=${location.origin}\nua=${navigator.userAgent.substring(0,80)}`;
          googleSigninSlot.innerHTML = '<button id="manual-google-reload" type="button" style="padding:12px 24px;font-size:1rem;border-radius:999px;border:1px solid #555;background:#1a1a2e;color:#fff;cursor:pointer">🔄 Reload Google sign-in</button>';
          googleSigninSlot.appendChild(dbg);
          const btn = document.getElementById('manual-google-reload');
          if (btn) btn.addEventListener('click', () => {
            googleSigninSlot.innerHTML = '';
            initGoogleSignIn(clientId);
          });
          setAuthError('Google button did not render. Use reload sign-in, or try another browser tab.');
        }
      }, 3000);
    }

    async function bootstrapAuth() {
      if (bootstrapAuthPromise) return bootstrapAuthPromise;

      bootstrapAuthPromise = (async () => {
        window.__voiceBoot = { stage: 'bootstrapAuth-start' };
        try {
          const res = await fetch('/api/session', { credentials: 'same-origin' });
          window.__voiceBoot = { stage: 'bootstrapAuth-session-response', status: res.status };
          const data = await res.json();
          const clientId = data.googleClientId || GOOGLE_CLIENT_ID;
          window.__voiceBoot = { stage: 'bootstrapAuth-session-json', authenticated: !!data.authenticated, hasClientId: !!clientId };
          if (data.authenticated) {
            showAuthenticatedApp(data);
          } else {
            showLogin();
            initGoogleSignIn(clientId);
          }
        } catch (error) {
          window.__voiceBoot = { stage: 'bootstrapAuth-error', message: error?.message || String(error) };
          setAuthError('Could not reach the server.');
        } finally {
          bootstrapAuthPromise = null;
        }
      })();

      return bootstrapAuthPromise;
    }

    async function logout() {
      await fetch('/api/logout', { method: 'POST', credentials: 'same-origin' });
      currentUser = null;
      showSelectScreen();
      showLogin();
      initGoogleSignIn(GOOGLE_CLIENT_ID);
    }

    audioBtn.addEventListener('click', startRoomAudio);
    connectBtn.addEventListener('click', () => {
      if (room || isConnecting || !selectedAgent) return;
      // Bambi starts clean only on an explicit Start Calling press. Internal
      // reconnect/recovery paths call connect() directly and keep this call's session.
      if (selectedAgent.id === 'bambi') {
        localStorage.removeItem('voice-session-bambi');
        currentSessionId = null;
        transcriptHistoryLoaded = false;
        transcriptPollIndex = 0;
        document.getElementById('transcript-log')?.replaceChildren();
        updateSessionIndicator();
      }
      connect();
    });
    // Mute toggle
    async function setMuteState(nextMuted) {
      if (!room) return;
      await room.localParticipant.setMicrophoneEnabled(
        !nextMuted,
        nextMuted ? undefined : MICROPHONE_CAPTURE_OPTIONS,
      );
      isMuted = nextMuted;
      muteBtn.classList.toggle('muted', isMuted);
      muteBtn.textContent = isMuted ? '🔇' : '🎤';
      muteBtn.setAttribute('aria-pressed', String(isMuted));
      muteBtn.setAttribute('aria-label', isMuted ? 'Unmute microphone' : 'Mute microphone');
      muteLabel.textContent = isMuted ? 'Unmute' : 'Mute';
      if (isMuted) {
        userSpeaking = false;
        updateSpeakingUI();
      }
    }

    async function toggleMute() {
      try {
        await setMuteState(!isMuted);
      } catch (error) {
        console.error('Mute toggle failed:', error);
        setStatus('Microphone control failed. Try again.', 'error');
      }
    }

    // Vision toggle — only enables camera after explicit user action
    async function toggleVision() {
      if (!room || !visionCapable) return;
      try {
        if (visionEnabled) {
          await room.localParticipant.setCameraEnabled(false);
          visionEnabled = false;
          visionBtn.classList.remove('active');
          visionBtn.setAttribute('aria-pressed', 'false');
          visionBtn.setAttribute('aria-label', 'Enable camera vision');
          visionLabel.textContent = 'Vision';
          clearLocalCameraPreview();
        } else {
          setStatus('Requesting camera permission...', 'connecting');
          await setCameraEnabledWithPlan(true);
          visionEnabled = true;
          visionBtn.classList.add('active');
          visionBtn.setAttribute('aria-pressed', 'true');
          visionBtn.setAttribute('aria-label', 'Disable camera vision');
          visionBtn.textContent = '👁';
          visionLabel.textContent = 'Vision On';
          await refreshCameraDevices();
          applyCameraMirror();
          showLocalCameraPreview();
          setStatus('Camera vision enabled', 'connected');
        }
      } catch (err) {
        console.error('Vision toggle failed:', err);
        visionEnabled = false;
        visionBtn.classList.remove('active');
        visionBtn.setAttribute('aria-pressed', 'false');
        visionBtn.setAttribute('aria-label', 'Enable camera vision');
        visionLabel.textContent = 'Vision';
        clearLocalCameraPreview();
        let message = err?.message || 'Camera failed to start';
        if (err?.name === 'NotAllowedError' || err?.name === 'PermissionDeniedError') {
          message = 'Camera permission was blocked. Allow camera access in Android Chrome and try again.';
        } else if (err?.name === 'NotFoundError' || err?.name === 'DevicesNotFoundError') {
          message = 'No camera was found on this device.';
        }
        setStatus(`Camera error: ${message}`, 'error');
      }
    }

    async function handleCameraSelectionChange(event) {
      const nextPreference = event.target.value || CAMERA_PREF_AUTO;
      persistCameraPreference(nextPreference);
      applyCameraMirror(nextPreference);

      if (!room || !visionEnabled) return;

      try {
        await switchActiveCamera(nextPreference);
        await refreshCameraDevices();
        applyCameraMirror(nextPreference, availableVideoInputs);
        showLocalCameraPreview();
        // Notify the agent that the camera changed so it can discard stale
        // buffered WebRTC frames, then send a fresh snapshot from the new
        // camera. Wait 350ms for the video element to start decoding frames
        // before capturing the snapshot.
        if (room && room.state === 'connected') {
          try {
            await room.localParticipant.publishData(
              new TextEncoder().encode(JSON.stringify({ type: 'camera_switched', preference: nextPreference })),
              { reliable: true }
            );
          } catch { /* best effort */ }
          await new Promise(r => setTimeout(r, 350));
          await sendCameraSnapshot('camera_switch', { force: true });
        }
      } catch (err) {
        console.error('Camera switch failed:', err);
        renderCameraSelect();
      }
    }

    endCallBtn.addEventListener('click', disconnect);
    newCallBtn.addEventListener('click', newSession);
    muteBtn.addEventListener('click', toggleMute);
    visionBtn.addEventListener('click', toggleVision);
    cameraSelect.addEventListener('change', handleCameraSelectionChange);

    // File attach button
    const attachBtn = document.getElementById('btn-attach');
    const attachInput = document.getElementById('attach-file-input');

    attachBtn.addEventListener('click', () => {
      if (!attachBtn.classList.contains('uploading')) {
        attachInput.click();
      }
    });

    attachInput.addEventListener('change', async () => {
      const file = attachInput.files[0];
      if (!file) { return; }
      setStatus(`📎 Uploading ${file.name} (${Math.round(file.size/1024)}KB)...`, 'connecting');
      if (attachmentStatus) attachmentStatus.textContent = `Validating and uploading ${file.name}…`;
      attachInput.value = ''; // reset so same file can be re-uploaded

      // If the file is an image, render an immediate thumbnail in the transcript
      // using a local data URL — no server round-trip needed for the preview.
      if (file.type && file.type.startsWith('image/')) {
        try {
          const dataUrl = await new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result);
            reader.onerror = () => reject(reader.error || new Error('FileReader failed'));
            reader.readAsDataURL(file);
          });
          const log = document.getElementById('transcript-log');
          if (log) {
            const previewEntry = document.createElement('div');
            previewEntry.className = 'transcript-entry';
            const sizeStr = file.size >= 1024 ? `${Math.round(file.size/1024)}KB` : `${file.size}B`;
            const safeName = String(file.name).replace(/[<>&"]/g, (c) => ({'<':'&lt;','>':'&gt;','&':'&amp;','"':'&quot;'}[c]));
            previewEntry.innerHTML =
              `<span class="speaker user">You:</span>` +
              `<span class="text">📎 sent an image</span>` +
              `<img class="attachment-thumb" alt="${safeName}" />` +
              `<div class="attachment-meta">${safeName} · ${sizeStr}</div>`;
            const img = previewEntry.querySelector('img.attachment-thumb');
            img.src = dataUrl;
            img.addEventListener('click', () => window.open(dataUrl, '_blank'));
            log.appendChild(previewEntry);
            scrollTranscriptToBottom();
          }
        } catch {
          // Preview is best-effort; upload itself proceeds either way.
        }
      }

      const agent = selectedAgent?.id || 'main';
      attachBtn.classList.add('uploading');
      attachBtn.textContent = '⏳';

      try {
        const formData = new FormData();
        formData.append('file', file);
        // Include session/room context in upload request
        const params = new URLSearchParams({ agent });
        if (room && room.name) params.set('room', room.name);
        if (room && room.name) params.set('session_id', room.name);
        const uploadUrl = `/api/upload?${params.toString()}`;
        const resp = await fetch(uploadUrl, {
          method: 'POST',
          body: formData,
          credentials: 'same-origin'
        });
        const result = await resp.json();
        if (result.success) {
          const sizeStr = result.size >= 1024 ? `${Math.round(result.size/1024)}KB` : `${result.size}B`;
          setStatus(`📎 ${result.filename} uploaded (${result.kind}, ${sizeStr})`, 'connected');
          if (attachmentStatus) attachmentStatus.textContent = `${result.filename} is ready for ${selectedAgent?.name || 'the agent'}.`;
          // Notify voice agent via LiveKit reliable data channel
          if (room && room.state === 'connected') {
            try {
              const notification = JSON.stringify({
                type: 'attachment_uploaded',
                attachment_id: result.attachment_id,
                filename: result.filename,
                original_filename: result.original_filename,
                path: result.path,
                mime_type: result.mime_type,
                kind: result.kind,
                size: result.size,
                sha256: result.sha256,
                agent: agent,
                session_id: room.name || null,
                room: room.name || null
              });
              await room.localParticipant.publishData(
                new TextEncoder().encode(notification),
                { reliable: true }
              );
            } catch {
              // data channel send failed — not fatal
            }
          }
        } else {
          console.error('[attach] server error:', result.error);
          setStatus(`❌ Upload failed: ${result.error}`, 'disconnected');
          if (attachmentStatus) attachmentStatus.textContent = `Could not attach ${file.name}: ${result.error || 'upload rejected'}.`;
        }
      } catch (e) {
        console.error('[attach] fetch error:', e);
        setStatus(`❌ Upload error: ${e.message}`, 'disconnected');
        if (attachmentStatus) attachmentStatus.textContent = `Could not attach ${file.name}. Check the connection and try again.`;
      } finally {
        attachBtn.classList.remove('uploading');
        attachBtn.textContent = '📎';
      }
    });
    newSessionBtn.addEventListener('click', clearSession);
    logoutBtn.addEventListener('click', logout);
    chatToggle.addEventListener('click', () => setChatOpen(!chatOpen));
    chatClose.addEventListener('click', () => setChatOpen(false));
    imageViewerClose.addEventListener('click', closeImageViewer);
    imageViewer.addEventListener('click', (event) => {
      if (event.target === imageViewer) closeImageViewer();
    });
    document.addEventListener('click', (event) => {
      const image = event.target.closest?.('img.attachment-thumb');
      if (!image || image.closest('#image-viewer')) return;
      event.preventDefault();
      const caption = image.alt || image.closest('.transcript-entry, .chat-bubble')?.querySelector('.attachment-meta')?.textContent || '';
      openImageViewer(image.currentSrc || image.src, caption);
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !imageViewer.hidden) closeImageViewer();
    });
    chatCommandButtons.forEach((button) => {
      button.addEventListener('click', () => runCommand(button.dataset.command));
    });

    historySearch?.addEventListener('input', () => {
      const query = historySearch.value.trim().toLocaleLowerCase();
      historyList.querySelectorAll('.history-card').forEach(card => {
        card.hidden = query && !card.textContent.toLocaleLowerCase().includes(query);
      });
    });

    document.getElementById('transcript-copy')?.addEventListener('click', async () => {
      const text = document.getElementById('transcript-log')?.innerText?.trim() || '';
      if (!text) return;
      await navigator.clipboard.writeText(text);
      setCallState('connected', 'Transcript copied', 'The visible conversation is on your clipboard.');
    });

    document.getElementById('transcript-download')?.addEventListener('click', () => {
      const text = document.getElementById('transcript-log')?.innerText?.trim() || '';
      if (!text) return;
      const link = document.createElement('a');
      link.href = URL.createObjectURL(new Blob([text + '\n'], { type: 'text/plain;charset=utf-8' }));
      link.download = `openclaw-${selectedAgent?.id || 'voice'}-${new Date().toISOString().slice(0, 10)}.txt`;
      link.click();
      URL.revokeObjectURL(link.href);
    });

    // ── Backend Transcript Polling ──
    let transcriptPollTimer = null;
    let transcriptPollIndex = 0;
    let transcriptHistoryLoaded = false;

    function startTranscriptPolling() {
      stopTranscriptPolling();
      transcriptPollIndex = 0;
      // Poll every 2s for tool calls and backend-captured messages
      transcriptPollTimer = setInterval(pollBackendTranscript, 1000);
    }

    function stopTranscriptPolling() {
      if (transcriptPollTimer) {
        clearInterval(transcriptPollTimer);
        transcriptPollTimer = null;
      }
    }

    function applyBackendStatus(status) {
      if (!selectedAgent) return;
      backendStatus = status && status.label ? status : null;
      if (!backendStatus) {
        updateSpeakingUI();
        return;
      }
      if (normalizeLevel(backendStatus.level) === 'processing') {
        isProcessing = true;
      } else if (normalizeLevel(backendStatus.level) === 'idle' || normalizeLevel(backendStatus.level) === 'speaking' || normalizeLevel(backendStatus.level) === 'error' || normalizeLevel(backendStatus.level) === 'user') {
        isProcessing = false;
      }
      updateSpeakingUI();
    }

    async function pollBackendTranscript() {
      if (!selectedAgent || !room) return;
      try {
        const params = new URLSearchParams({
          agent: selectedAgent.id,
          session: currentSessionId || '',
          after: String(transcriptPollIndex),
        });
        const res = await fetch(`/api/live-transcript?${params}`, { credentials: 'same-origin' });
        if (!res.ok) return;
        const data = await res.json();
        applyBackendStatus(data.status);
        if (!data.messages?.length) return;

        // For persisted (non-live) data, only load history once to avoid duplication
        if (!data.live) {
          if (transcriptHistoryLoaded) return;
          transcriptHistoryLoaded = true;
        }

        const log = document.getElementById('transcript-log');
        if (!log) return;

        for (const msg of data.messages) {
          const role = String(msg.role || '').toLowerCase();
          const entry = document.createElement('div');

          const content = String(msg.content || '').trim();

          if ((role.includes('user') || role === 'userrole.user') && !isLikelyGhostUtterance(content)) {
            entry.className = 'transcript-entry speaker-user';
            entry.innerHTML = `<span class="speaker user">You:</span><span class="text">${renderContent(content)}</span>`;
          } else if (role.includes('assistant') || role === 'userrole.assistant') {
            const name = selectedAgent?.name || 'Agent';
            entry.className = 'transcript-entry speaker-agent';
            entry.innerHTML = `<span class="speaker agent">${name}:</span><span class="text">${renderContent(content)}</span>`;
          } else if (role === 'tool_call') {
            const content = `🔧 ${msg.name || 'tool'}(${JSON.stringify(msg.args || {}).slice(0, 80)})`;
            entry.className = 'transcript-entry speaker-agent';
            entry.innerHTML = `<span class="speaker agent" style="color:#eab308">Tool:</span><span class="text" style="font-size:0.75rem;color:#999;font-family:monospace">${escapeHtml(content)}</span>`;
          } else if (role === 'tool_result') {
            const content = `← ${msg.name || 'result'}: ${(msg.content || '').slice(0, 150)}`;
            entry.className = 'transcript-entry speaker-agent';
            entry.innerHTML = `<span class="speaker agent" style="color:#eab308">Tool:</span><span class="text" style="font-size:0.75rem;color:#999;font-family:monospace">${escapeHtml(content)}</span>`;
          } else {
            continue; // Skip unknown roles
          }

          log.appendChild(entry);
        }

        // Auto-scroll
        scrollTranscriptToBottom();

        transcriptPollIndex = data.total;
      } catch {
        // Silent, but reset stale backend-only status if polling dies
        backendStatus = null;
      }
    }

    // ── Session History ──

    function setHistoryOpen(open) {
      appShell.inert = open;
      historyOverlay.classList.toggle('open', open);
      historyOverlay.setAttribute('aria-hidden', open ? 'false' : 'true');
      historyOverlay.inert = !open;
      if (open) {
        loadHistory();
        historyClose.focus();
      } else {
        historyBtn.focus();
      }
    }

    function renderHistoryFilters() {
      historyFilters.innerHTML = '';
      const filterAgents = [{ id: 'all', name: 'All', emoji: '✨' }, ...visibleAgents];
      for (const agent of filterAgents) {
        const pill = document.createElement('button');
        pill.type = 'button';
        pill.className = `history-filter-pill${historyAgentFilter === agent.id ? ' active' : ''}`;
        pill.textContent = `${agent.emoji} ${agent.name}`;
        pill.addEventListener('click', () => {
          if (historyAgentFilter === agent.id) return;
          historyAgentFilter = agent.id;
          renderHistoryFilters();
          loadHistory();
        });
        historyFilters.appendChild(pill);
      }
    }

    function showHistoryList() {
      historyList.style.display = '';
      historyDetail.classList.remove('visible');
      const activeAgent = historyAgentFilter === 'all'
        ? { name: 'All agents', emoji: '✨' }
        : visibleAgents.find(a => a.id === historyAgentFilter) || { name: 'Agent', emoji: '🤖' };
      historyTitle.textContent = `📜 Past Sessions · ${activeAgent.emoji} ${activeAgent.name}`;
      historyFilters.style.display = 'flex';
      renderHistoryFilters();
    }

    let historyAbortCtrl = null;
    let historyRequestId = 0;
    let detailAbortCtrl = null;
    let detailRequestId = 0;

    async function loadHistory() {
      showHistoryList();
      historyList.innerHTML = '<div class="history-empty">Loading...</div>';

      // Cancel any previous in-flight list/detail fetches so they can't lock
      // up the browser connection pool or land late and overwrite state.
      if (historyAbortCtrl) { try { historyAbortCtrl.abort(); } catch { /* already settled */ } }
      if (detailAbortCtrl) { try { detailAbortCtrl.abort(); } catch { /* already settled */ } }
      historyAbortCtrl = new AbortController();
      const myId = ++historyRequestId;
      const signal = historyAbortCtrl.signal;

      try {
        const agentIds = historyAgentFilter === 'all'
          ? visibleAgents.map(agent => agent.id)
          : [historyAgentFilter];

        const results = await Promise.all(agentIds.map(async (agentId) => {
          const res = await fetch(`/api/sessions?agent=${encodeURIComponent(agentId)}&limit=100`, {
            credentials: 'same-origin',
            signal,
          });
          if (!res.ok) throw new Error(`Failed to load sessions: ${res.status} ${res.statusText}`);
          const data = await res.json();
          return (data.sessions || []).map(session => ({ ...session, agent_id: agentId }));
        }));

        // Stale-response guard: a newer loadHistory started — drop this result.
        if (myId !== historyRequestId) return;

        const sessions = results
          .flat()
          .sort((a, b) => new Date(b.started_at || 0).getTime() - new Date(a.started_at || 0).getTime());

        if (sessions.length === 0) {
          historyList.innerHTML = '<div class="history-empty">No past sessions yet.<br>Start a voice call and they\'ll show up here.</div>';
          return;
        }

        historyList.innerHTML = '';
        for (const s of sessions) {
          const agent = visibleAgents.find(a => a.id === s.agent_id) || AGENTS.find(a => a.id === s.agent_id) || { name: s.agent_id || 'Unknown', emoji: '🤖' };
          const card = document.createElement('button');
          card.type = 'button';
          card.className = 'history-card';
          card.dataset.agentId = s.agent_id || '';
          card.dataset.filename = s.file || '';

          const date = s.started_at ? new Date(s.started_at) : null;
          const dateStr = date ? date.toLocaleString(undefined, {
            month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit'
          }) : 'Unknown';

          const dur = s.duration_seconds || 0;
          const durStr = dur < 60 ? `${Math.round(dur)}s` : `${Math.round(dur / 60)}m`;

          card.innerHTML = `
            <div class="history-card-top">
              <span class="history-card-date">${dateStr}</span>
              <span class="history-card-duration">${durStr}</span>
            </div>
            <div class="history-card-agent"><span class="history-card-emoji">${agent.emoji}</span><span>${agent.name}</span></div>
            <div class="history-card-summary">${escapeHtml(s.summary || 'No summary')}</div>
            <div class="history-card-msgs">${s.message_count || 0} messages</div>
          `;
          card.addEventListener('click', () => loadSessionDetail(card.dataset.filename, card.dataset.agentId));
          historyList.appendChild(card);
        }
      } catch (err) {
        if (err && err.name === 'AbortError') return;
        if (myId !== historyRequestId) return;
        historyList.innerHTML = '';
        const errorMessage = document.createElement('div');
        errorMessage.className = 'history-empty';
        errorMessage.textContent = `Failed to load sessions: ${err.message}`;
        historyList.appendChild(errorMessage);
      }
    }

    async function loadSessionDetail(filename, agentId) {
      historyList.style.display = 'none';
      historyFilters.style.display = 'none';
      historyDetail.classList.add('visible');
      historyTranscript.innerHTML = '<div class="history-empty">Loading...</div>';

      // Abort any previous detail fetch so a slow one can't land on top of a
      // newer click, and so the browser connection pool stays clean.
      if (detailAbortCtrl) { try { detailAbortCtrl.abort(); } catch { /* already settled */ } }
      detailAbortCtrl = new AbortController();
      const myId = ++detailRequestId;
      const signal = detailAbortCtrl.signal;

      try {
        const res = await fetch(
          `/api/sessions/${encodeURIComponent(filename)}?agent=${encodeURIComponent(agentId)}`,
          { credentials: 'same-origin', signal }
        );
        if (!res.ok) throw new Error('Session not found');
        const data = await res.json();
        if (myId !== detailRequestId) return;

        const agent = visibleAgents.find(a => a.id === agentId) || AGENTS.find(a => a.id === agentId) || { name: agentId || 'Unknown', emoji: '🤖' };
        const date = data.started_at ? new Date(data.started_at) : null;
        const dur = data.duration_seconds || 0;
        const durStr = dur < 60 ? `${Math.round(dur)}s` : `${Math.round(dur / 60)}m`;
        historyDetailMeta.textContent = `${agent.emoji} ${agent.name} · ${date ? date.toLocaleString() : 'Unknown'} · ${durStr} · ${(data.messages || []).length} msgs`;
        historyContinue.onclick = () => {
          const target = visibleAgents.find(item => item.id === agentId);
          if (!target) return;
          selectAgent(target);
          if (data.session_id) localStorage.setItem(`voice-session-${agentId}`, data.session_id);
          updateSessionIndicator();
          setHistoryOpen(false);
          connectBtn.focus();
          setStatus(`Ready to continue with ${agent.name}`, 'disconnected');
        };

        historyTranscript.innerHTML = '';
        if (data.summary) {
          const summaryEl = document.createElement('div');
          summaryEl.className = 'ht-msg tool';
          const summaryHeading = document.createElement('div');
          summaryHeading.className = 'ht-time';
          summaryHeading.textContent = 'Summary';
          const summaryBody = document.createElement('div');
          summaryBody.innerHTML = renderContent(String(data.summary));
          summaryEl.append(summaryHeading, summaryBody);
          historyTranscript.appendChild(summaryEl);
        }

        for (const msg of (data.messages || [])) {
          const el = document.createElement('div');
          const role = String(msg.role || '').toLowerCase();
          let cls = 'assistant';
          if (role.includes('user')) cls = 'user';
          else if (role === 'tool_call' || role === 'tool_result') cls = 'tool';

          el.className = `ht-msg ${cls}`;

          let timeStr = '';
          if (msg.ts) {
            try {
              const t = new Date(msg.ts);
              timeStr = t.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' });
            } catch { /* malformed timestamp */ }
          }

          let content = '';
          if (role === 'tool_call') {
            content = `🔧 ${msg.name || 'tool'}(${JSON.stringify(msg.args || {}).slice(0, 100)})`;
          } else if (role === 'tool_result') {
            content = `← ${msg.name || 'result'}: ${(msg.content || '').slice(0, 200)}`;
          } else {
            content = msg.content || '';
          }

          // Use renderContent for user/assistant roles so image URLs become thumbnails;
          // tool messages are monospace/code-like so plain escaping is safer there.
          const renderedContent = (role === 'tool_call' || role === 'tool_result')
            ? escapeHtml(content)
            : renderContent(content);
          el.innerHTML = `${timeStr ? `<div class="ht-time">${timeStr}</div>` : ''}${renderedContent}`;
          historyTranscript.appendChild(el);
        }
      } catch (err) {
        if (err && err.name === 'AbortError') return;
        if (myId !== detailRequestId) return;
        historyTranscript.innerHTML = '';
        const errorMessage = document.createElement('div');
        errorMessage.className = 'history-empty';
        errorMessage.textContent = `Failed: ${err.message}`;
        historyTranscript.appendChild(errorMessage);
      }
    }

    function isLikelyGhostUtterance(text) {
      const t = String(text || '').trim().toLowerCase();
      if (!t) return true;
      return [
        'thank you.', 'thank you', 'thanks.', 'thanks',
        'you\'re welcome.', 'you\'re welcome'
      ].includes(t);
    }

    function escapeHtml(text) {
      const div = document.createElement('div');
      div.textContent = text;
      return div.innerHTML;
    }

    // Render text content: detect image URLs and render as thumbnails, other URLs as links
    function renderContent(text) {
      // Pre-process: expand [Image: url] markers the agent embeds in text responses
      // into bare URLs so the URL detection below can render them as thumbnails.
      text = text.replace(/\[Image:\s*(https?:\/\/[^\]\s]+)\]/gi, '$1');

      const urlRegex = /(https?:\/\/[^\s<>"']+|\/portal-images\/[^\s<>"']+)/g;
      const imageExtRegex = /\.(jpg|jpeg|png|gif|webp|svg|bmp|avif)(\?[^\s]*)?$/i;
      // Portal-images path: always an image, no guessing needed
      const portalImageRegex = /^\/portal-images\//;
      // Match /photo/, /image/, /img/, /photos/, /images/, /media/ anywhere in path,
      // OR well-known image CDN hostnames (unsplash, imgur, pbs.twimg, etc.)
      const imageHostRegex = /\/(photo|image|img|photos|images|media)\//i;
      const imageDomainRegex = /^https?:\/\/(?:[^/]*\.)?(unsplash\.com|imgur\.com|i\.imgur\.com|pbs\.twimg\.com|cdn\.discordapp\.com|media\.giphy\.com|upload\.wikimedia\.org|raw\.githubusercontent\.com\/[^/]+\/[^/]+\/[^/]+\/.*\.(png|jpg|jpeg|gif|webp))/i;

      const _imgTag = (url) => {
        const href = url.startsWith('/') ? url : escapeHtml(url);
        const src = url.startsWith('/') ? url : escapeHtml(url);
        return `<a href="${href}" target="_blank" rel="noopener"><img class="attachment-thumb" src="${src}" alt="image" style="max-width:260px;max-height:180px;border-radius:8px;margin-top:6px;display:block;cursor:pointer;" onerror="this.style.display='none';this.nextSibling&&(this.nextSibling.style.display='inline')"/><span style="display:none;color:#6b7280;font-size:0.75rem">[image failed to load]</span></a>`;
      };

      let html = '';
      let lastIndex = 0;
      let match;

      while ((match = urlRegex.exec(text)) !== null) {
        // Append escaped text before this URL
        if (match.index > lastIndex) {
          html += escapeHtml(text.slice(lastIndex, match.index));
        }

        const url = match[0];
        if (portalImageRegex.test(url) || imageExtRegex.test(url) || imageHostRegex.test(url) || imageDomainRegex.test(url)) {
          // Render as inline image thumbnail
          html += _imgTag(url);
        } else {
          // Render as clickable link
          html += `<a href="${escapeHtml(url)}" target="_blank" rel="noopener" style="color:#818cf8;word-break:break-all">${escapeHtml(url)}</a>`;
        }

        lastIndex = match.index + url.length;
      }

      // Append remaining text
      if (lastIndex < text.length) {
        html += escapeHtml(text.slice(lastIndex));
      }

      return html || escapeHtml(text);
    }

    historyBtn.addEventListener('click', () => setHistoryOpen(true));
    historyClose.addEventListener('click', () => setHistoryOpen(false));
    historyBack.addEventListener('click', () => {
      // Cancel any pending detail fetch so it doesn't paint stale data later.
      if (detailAbortCtrl) { try { detailAbortCtrl.abort(); } catch { /* already settled */ } }
      detailRequestId++;
      showHistoryList();
    });

    addChatMessage('system', 'Type /help for command tricks. Nasty little goblin panel is live.');

    // Clear transcript on page load — start blank, backend fills it
    const _tlog = document.getElementById('transcript-log');
    if (_tlog) _tlog.innerHTML = '';

    // ── Transcript long-press → fullscreen, swipe-down → dismiss ──────────
    (function () {
      const panel = document.getElementById('transcript-panel');
      if (!panel) return;

      let longPressTimer = null;
      let pointerStartY = 0;
      let pointerStartX = 0;
      const LONG_PRESS_MS = 500;
      const MOVE_CANCEL_PX = 12;
      const SWIPE_DISMISS_PX = 80; // drag down ≥ this to dismiss fullscreen

      const log = panel.querySelector('.transcript-log');

      function expandFullscreen() {
        panel.classList.add('fullscreen');
        document.body.style.overflow = 'hidden'; // block iOS pull-to-refresh
        // scroll to bottom in fullscreen
        const el = log || panel;
        el.scrollTop = el.scrollHeight;
      }

      function collapseFullscreen() {
        panel.classList.remove('fullscreen');
        document.body.style.overflow = ''; // restore page scroll
        panel.style.transform = '';
        panel.style.transition = '';
        const el = log || panel;
        el.scrollTop = el.scrollHeight;
      }

      // ── Collapsed mode: long-press detection ──────────────────────────────
      panel.addEventListener('pointerdown', (e) => {
        if (panel.classList.contains('fullscreen')) return;
        pointerStartX = e.clientX;
        pointerStartY = e.clientY;
        panel.classList.add('longpress-active');
        longPressTimer = setTimeout(() => {
          panel.classList.remove('longpress-active');
          expandFullscreen();
        }, LONG_PRESS_MS);
      });

      panel.addEventListener('pointermove', (e) => {
        if (panel.classList.contains('fullscreen')) return;
        const dx = Math.abs(e.clientX - pointerStartX);
        const dy = Math.abs(e.clientY - pointerStartY);
        if (dx > MOVE_CANCEL_PX || dy > MOVE_CANCEL_PX) {
          clearTimeout(longPressTimer);
          panel.classList.remove('longpress-active');
        }
      });

      ['pointerup', 'pointercancel'].forEach(ev => {
        panel.addEventListener(ev, () => {
          if (panel.classList.contains('fullscreen')) return;
          clearTimeout(longPressTimer);
          panel.classList.remove('longpress-active');
        });
      });

      // ── Fullscreen mode: swipe-down on header to dismiss (no tap-to-close) ──
      let fsStartY = 0;
      let fsDragging = false;

      // Only the drag-handle (header zone) triggers drag-to-dismiss.
      // The transcript log body is left alone so it can scroll freely.
      const fsDragHandle = panel.querySelector('.transcript-drag-handle');
      const fsDragTarget = fsDragHandle || panel; // fallback to panel if handle missing

      fsDragTarget.addEventListener('pointerdown', (e) => {
        if (!panel.classList.contains('fullscreen')) return;
        fsStartY = e.clientY;
        fsDragging = true;
        panel.style.transition = 'none';
      }, { passive: true });

      // pointermove / pointerup / pointercancel still on panel so the gesture
      // continues tracking even if the finger drifts off the handle.
      panel.addEventListener('pointermove', (e) => {
        if (!fsDragging || !panel.classList.contains('fullscreen')) return;
        const dy = e.clientY - fsStartY;
        // Follow finger down only when dragging from the header
        if (dy > 0) {
          panel.style.transform = `translateY(${dy}px)`;
        }
      }, { passive: true });

      panel.addEventListener('pointerup', (e) => {
        if (!fsDragging || !panel.classList.contains('fullscreen')) return;
        fsDragging = false;
        const dy = e.clientY - fsStartY;
        if (dy >= SWIPE_DISMISS_PX) {
          // Swipe-down ≥ threshold → animate out and collapse
          panel.style.transition = 'transform 0.2s ease';
          panel.style.transform = `translateY(100vh)`;
          setTimeout(() => collapseFullscreen(), 200);
        } else {
          // Partial drag → snap back
          panel.style.transition = 'transform 0.2s ease';
          panel.style.transform = 'translateY(0)';
          setTimeout(() => { panel.style.transform = ''; panel.style.transition = ''; }, 200);
        }
      });

      // pointercancel = browser took over (e.g. scroll); reset drag state + snap back
      panel.addEventListener('pointercancel', () => {
        if (!fsDragging || !panel.classList.contains('fullscreen')) return;
        fsDragging = false;
        panel.style.transition = 'transform 0.2s ease';
        panel.style.transform = 'translateY(0)';
        setTimeout(() => { panel.style.transform = ''; panel.style.transition = ''; }, 200);
      });

      // Block pull-to-refresh: check the inner log's scrollTop, not panel's
      panel.addEventListener('touchmove', (e) => {
        if (!panel.classList.contains('fullscreen')) return;
        const scrollEl = log || panel;
        if (scrollEl.scrollTop <= 0) e.preventDefault();
      }, { passive: false });

      // Close button
      const fsCloseBtn = panel.querySelector('.transcript-fs-close');
      if (fsCloseBtn) {
        fsCloseBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          collapseFullscreen();
        });
        fsCloseBtn.addEventListener('pointerdown', (e) => e.stopPropagation()); // don't trigger drag
      }

      // ESC key dismisses
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && panel.classList.contains('fullscreen')) {
          collapseFullscreen();
        }
      });
    })();
    // ── End transcript fullscreen ──────────────────────────────────────────

    bootstrapAuth();
